import * as tslib_1 from "tslib";
import { Job } from '../../../models/job';
import { JobSalary } from '../../../models/jobSalary';
import { JobMatchQueryFilter } from '../../../models/jobMatchQueryFilter';
import { Requisition } from '../../../models/requisition';
import { SentAssessmentDetail } from '../../../models/sentAssessmentDetail';
import { UiError } from '../../../models/uiError';
import * as UploadReqUpdateLocationModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-update-location-modal.html';
import * as UploadReqTransactionsCandidateModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-transaction-candidates-modal.html';
import * as UploadReqWorkflowStepWarningModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-work-flow-step-warning-modal.html';
import * as UploadReqJobProfileModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-job-profile-modal.html';
import * as UploadReqAddEditEndClientTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/uploadreq/upload-req-add-edit-end-client.html';
import { RunCandidateScore } from '../../../models/runCandidateScore';
import { FormalizeCompany, FormalizeRequisition } from '../../../models/formalizePayload';
var UploadReqPageController = /** @class */ (function () {
    /*@ngInject*/
    function UploadReqPageController($rootScope, $scope, $state, $transitions, $uibModal, $sce, $timeout, requisitionService, candidateService, resumeService, jobService, assessmentService, planService, companyService, alertsAndNotificationsService, MESSAGECONSTANTS, uibModalService, utilityService, userService, manageSkillsService, stateManagementStorageService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$transitions = $transitions;
        this.$uibModal = $uibModal;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.requisitionService = requisitionService;
        this.candidateService = candidateService;
        this.resumeService = resumeService;
        this.jobService = jobService;
        this.assessmentService = assessmentService;
        this.planService = planService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.utilityService = utilityService;
        this.userService = userService;
        this.manageSkillsService = manageSkillsService;
        this.stateManagementStorageService = stateManagementStorageService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    UploadReqPageController.prototype._ensureWizardInitialized = function () {
        var $el = $('#uploadReqWizard');
        this.$timeout(function () {
            if ($el.length && !$el.data('wizard')) {
                $el.wizard();
            }
        }, 300, false);
    };
    UploadReqPageController.prototype.$onInit = function () {
        var _this = this;
        this.utilityService.showLoadingModal("Loading...");
        this.$stateParams = this.$transition$.params();
        this.isNewReq = (!_.isUndefined(this.$stateParams.isNewReq) && !_.isNull(this.$stateParams.isNewReq)) ? this.$stateParams.isNewReq : null;
        this.asyncActionType = this.$stateParams.asyncActionType ? this.$stateParams.asyncActionType : 'UPLOAD';
        this.isLoading = true;
        this.requisitionSkillsLoading = false;
        this.allExistingSkills = [];
        this.allExistingDegrees = [];
        this.allExistingFieldOfStudy = [];
        this.allExistingRoles = [];
        this.allExistingCertificates = [];
        this.allExistingJDActionWords = [];
        this.allUpdatedJDActionWords = [];
        this.timePeriods = [];
        this.skillsTimePeriods = [];
        this.getAllMasterLists(function () {
            _this._initVariables();
            _this._initUploadWizard();
            _this._handleBrowserEvents();
            _this._setContractDurations();
            _this.getPlanDetails(function () {
                if (_this.isTrialPlanActive) {
                    _this.getJobBoardsResumePullLimits();
                }
            });
            _this.getSalaryDurationOptions();
            _this.getCurrencyCodes();
            _this.checkJobBoardsSearchAvailability();
            // if not edit mode
            if (!_this.editModeFlag) {
                //initialize the variables
                _this.job = new Job();
                _this.isJobFetched = true;
                _this.showWizardSteps = true;
                _this._ensureWizardInitialized();
                _this.currentJobStatus = 'DRAFT';
                _this.isActivateRequisitionEnabled = false;
                // get all the required values.
                // get clients or bus
                _this.getAllClientsOrBu();
                // get recruiters
                // this.getRecruiters();
                // get job types
                _this.getAllJobTypes();
                //get work locations
                _this.getAllWorkLocations();
                // get sponsorship types
                _this.getAllSponsorshipTypes();
                // get tech assessments
                _this.getAllTechAssessments();
                // get value assessments
                _this.getAllValueAssessments();
                // get job boards
                _this.getAllJobBoards();
                _this._createStepTempObject(1);
                _this.utilityService.hideLoadingModal();
            }
            else {
                // edit mode
                _this.getJob(_this.$stateParams.jobId, function (data) {
                    _this.currentJobStatus = 'OPEN';
                    if (data.jobCurrentState == 'DRAFT') {
                        _this.currentJobStatus = 'DRAFT';
                        _this.isActivateRequisitionEnabled = false;
                    }
                    else {
                        _this._ensureWizardInitialized();
                    }
                    _this.showWizardSteps = true;
                    _this.req.title = data.title;
                    _this.req.isSharedClientRequisition = data.isSharedClientRequisition;
                    _this.req.sharedClientBuOrCorpId = data.sharedClientBuOrCorpId;
                    var fileName = _this._getFileName(data);
                    var fileSize = data.jobRequisitionList[0].fileSize ? data.jobRequisitionList[0].fileSize : 0;
                    //check if job scoring job in is progress 
                    _this.getJobScoringJobStatus();
                    // get clients or bus
                    _this.getAllClientsOrBu(function () {
                        _this._setClientOrBu(data.clientorbu);
                        _this._createStepTempObject(2);
                        if (!_this.isCorporate) {
                            _this._getSharedClientBus(function () {
                                _this.getPointOfContacts(function () {
                                    _this._setPocs();
                                });
                            });
                        }
                    });
                    // get recruiters
                    _this.getRecruiters(function () {
                        _this._setRecruitersAndHiringManagers();
                    });
                    //get bu vendors
                    if (!_this.clientOrBUIsRequiredFlag) {
                        _this.getBuVendors(function () {
                            _this._setBuVendors();
                        });
                    }
                    // get job types
                    _this.getAllJobTypes(function () {
                        _this._setJobType();
                    });
                    // get job types
                    _this.getAllWorkLocations(function () {
                        if (_this.job.workLocationIds && _this.job.workLocationIds.length > 0) {
                            _this._setWorkLocations();
                        }
                    });
                    // get sponsorship types
                    _this.getAllSponsorshipTypes(function () {
                        if (_this.job.sponsorships) {
                            if (_this.job.sponsorships.length > 0) {
                                _this._setSponsorshipType();
                            }
                        }
                        else {
                            _this._setSponsorshipSelectedDefault(false);
                        }
                    });
                    // get tech assessments
                    _this.getAllTechAssessments();
                    // get value assessments
                    _this.getAllValueAssessments();
                    // get job boards
                    _this.getAllJobBoards(function () {
                        _this._setJobBoardDetails();
                    });
                    // get license preferences as job id is available
                    _this.getLicensePreferences(function () {
                        _this._createWorkflowSliders(function () {
                            _this._massageWorkflowStepsOrder();
                        });
                        _this.disableNextButtonFlag = false;
                    });
                    if (fileName) {
                        _this._setFileInUploadDropZone(fileName, fileSize);
                    }
                    //set the flags for edit mode
                    _this.disableUploadButtonFlag = true;
                    _this.fileExistsFlag = true;
                    _this.step2DetailsSavedFlag = true;
                    _this.workflowStepsSavedFlag = true;
                    _this.jobBoardsSettingsSavedFlag = true;
                    if (_this.isNewReq) {
                        _this.utilityService.showLoadingModal("Loading...");
                        _this._getCandidateCountBeforeStep5(function () {
                            _this._createCountSliders();
                            // find the remove button in the drop zone and delete it.
                            $('.dz-remove').remove();
                            // move to next step as the save is done.
                            $("#uploadReqWizard").wizard('previous');
                            _this.utilityService.hideLoadingModal();
                            _this.disableSaveButtonFlag = false;
                        }, function () {
                            _this.utilityService.hideLoadingModal();
                            _this.disableSaveButtonFlag = false;
                            //do nothing. error message will show up. no move to next step.
                        });
                    }
                    if (_this.asyncActionType && _this.asyncActionType != 'UPLOAD') {
                        _this.disableSaveButtonFlag = false;
                    }
                    _this._createStepTempObject(1);
                    _this.utilityService.hideLoadingModal();
                });
            }
            _this._checkIfOutreachEnabled();
        });
        this.setFormalizeActivityPayload();
    };
    UploadReqPageController.prototype._initVariables = function () {
        this.isJobFetched = false;
        this.isUploadRequisition = true;
        this.isTransitionAbortRequired = true;
        this.userDetails = this.$rootScope.userDetails;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.sharedCorporateId = null;
        this.clientorbulist = {};
        this.recruiterList = [];
        this.hiringManagerList = [];
        this.selectedRecruiters = [];
        this.sharedJobPocs = [];
        this.selectedPocs = [];
        this.selectedHiringManagers = [];
        this.selectedPrimaryHiringManager = [];
        this.selectedVendors = [];
        this.salaryDurationOptions = [];
        this.currencyCodes = [];
        this.jobTypeList = [];
        this.selectedJobTypes = [];
        this.workLocationsList = [];
        this.selectedWorkLocationsList = [];
        this.sponsorshipList = [];
        this.selectedSponsorships = [];
        this.techAssessmentList = [];
        this.valueAssessmentList = [];
        this.jobBoardDetails = [];
        this.jobBoardDetailsCopy = [];
        this.resumesToPullPerJobBoardCountCopy = 0;
        this.currentScoreCandidateCounts = {};
        this.adjustedScoreCandidateCounts = {};
        this.candidatesBasedOnRequisitionTransaction = [];
        this.req = {};
        this.job = {};
        this.salaryLabel = "Salary";
        this.reqUploadDropzone = {};
        this.uploadReqWizard = {};
        this.currentJobStatus = null;
        this.matchTypesArray = [];
        this.resumePullCounts = [5, 10, 15, 20, 25];
        this.radiusOptions = [];
        this.recencyOptions = [];
        this.jobBoardParameters = {};
        this.jobBoardParametersMatrix = [];
        this.jobBoardsResumePullLeft = 0;
        this.jobBoardsPullResumePulled = 0;
        this.activeJobBoardsFilterTabNumber = 0;
        this.clientOrBuLabel = 'Client';
        this.primaryHiringManagerId = '';
        this.sharedClientBus = [];
        this.sentTechnicalAssessmentsDetail = new SentAssessmentDetail();
        this.sentValueAssessmentsDetail = new SentAssessmentDetail();
        // Edit requistion details screen
        this.isEditRequisitionDetails = false;
        this.isUploadAndEditRadioBtn = true;
        this.endClient = null;
        this.addEditClientName = "";
        this.endClientSearchText = "";
        this.endClientDeleteMessage = "";
        this.associatedEdClientReqDetails = [];
        //preference objects
        this.intelligencePreferences = {};
        this.techAssessmentPreferences = {};
        this.valueAssessmentPreferences = {};
        this.verificationPreferences = {};
        // flags
        this.isCorporate = false;
        this.editModeFlag = false;
        this.candidatesPresentOnJob = false;
        this.disableWorkflowSettings = false;
        this.isLicensePreferenceSet = false;
        this.isJobBoardDetailsSet = true;
        this.hasClientOrBuChanged = false;
        this.hasJobTypeChanged = false;
        this.isClientOrBuDisabled = false;
        this.isFileUploadEnabled = true;
        this.isInitialStateDraft = false;
        this.clientOrBUIsRequiredFlag = true;
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.savingFlag = false;
        this.step2DetailsSavedFlag = false;
        this.workflowStepsSavedFlag = false;
        this.jobBoardsSettingsSavedFlag = false;
        this.disablePrevButtonFlag = true;
        this.disableSaveButtonFlag = true;
        this.disableNextButtonFlag = true;
        this.disableCancelButtonFlag = false;
        this.disableAllButtonsFlag = false;
        this.fileUploadInProgressFlag = false;
        this.loadingAdjustedCandidatesCountFlag = false;
        this.step2RequestWasInProgressFlag = false;
        this.step3RequestWasInProgressFlag = false;
        this.step4RequestWasInProgressFlag = false;
        this.step5RequestWasInProgressFlag = false;
        this.step6RequestWasInProgressFlag = false;
        this.editTitleFlag = false;
        this.editJobLocationFlag = false;
        this.editBUFlag = false;
        this.isResumePullEnabled = false;
        this.isJobBoardSelected = false;
        this.isJobIntegrationEnabledByPlan = false;
        this.isTrialPlanActive = false;
        this.isJobBoardServiceUp = true;
        this.isActivateRequisitionEnabled = true;
        this.isAnyWorkflowStepsEnabled = false;
        this.isLoadingSharedClientBus = false;
        this.isClientOrBuRequired = false;
        this.isFutureMatchesOnly = true;
        this.isEndClientNameValid = false;
        this.isManageEndClient = false;
        this.isJobTypeChanged = false;
        this.isAsyncProcess = false;
        this.isJobLocationChanged = false;
        this.isUiCanExit = false;
        this.isOutreachEnabled = false;
        this.isWorkFlowStep4Dot5ScoreChanged = false;
        this.isSkillsChanged = false;
        // temp objects for comparison
        this.step1DetailsTempObject = {};
        this.step2DetailsTempObject = {};
        this.workflowStepsTempObject = {};
        this.jobBoardsSettingsTempObject = {};
        //error objects
        this.step1Error = null;
        this.step2Error = null;
        this.step3Error = null;
        this.step4Error = null;
        this.step5Error = null;
        this.showWizardSteps = false;
        // set add or edit mode
        if (this.$stateParams.jobId != null) {
            this.editModeFlag = true;
            this.isClientOrBuDisabled = true;
            this.isFileUploadEnabled = false;
            this.isUploadRequisition = false;
            this.disableSaveButtonFlag = false;
        }
        if (this.$stateParams.jobState != null && (this.$stateParams.jobState == 'Draft' || this.$stateParams.jobState == 'DRAFT')) {
            this.isInitialStateDraft = true;
        }
        // if corporate, set the BU required flag as false.
        if (this.userDetails.company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            this.clientOrBUIsRequiredFlag = false;
            this.clientOrBuLabel = "BU";
        }
        this.isCorporate = this.companyService.isCorporateCompany();
        //initialize the drop zone configuration
        this.reqUploadDropzone = this.createReqUploadDropzone();
        this.req = new Requisition();
        // set the values from session
        this.companyId = this.userDetails.company.companyId;
        this.userId = this.userDetails.id;
        // error objects
        this.step1Error = new UiError();
        this.step2Error = new UiError();
        this.step3Error = new UiError();
        this.step4Error = new UiError();
        this.step5Error = new UiError();
        this.isStepOneActive = true;
        this.isRecalcucateScoreNoClicked = false;
    };
    UploadReqPageController.prototype._setContractDurations = function () {
        this.contractDurations = ["1", "2", "3", "3+", "4", "5", "6", "6+", "7", "8", "9", "9+", "10", "11", "12", "12+", "15", "18", "21", "24", "Long Term"];
    };
    UploadReqPageController.prototype.setDataAfterStep1Saved = function (data) {
        var _this = this;
        this._createStepTempObject(data.step + 1);
        if (!this.editModeFlag) {
            this.getRecruiters(function () {
                _this._setRecruitersAndHiringManagers();
            });
            if (!this.isCorporate) {
                this.getPointOfContacts(function () {
                    _this._setPocs();
                });
            }
            if (!this.clientOrBUIsRequiredFlag) {
                this.getBuVendors(function () {
                    _this._setBuVendors();
                });
            }
        }
    };
    UploadReqPageController.prototype._initUploadWizard = function () {
        var _this = this;
        // Handle Wizard operations
        $('#uploadReqWizard').on('actionclicked.fu.wizard', function (evt, data) {
            if (data.direction == "next") {
                var currentStep = data.step;
                if (!_this.isInitialStateDraft) {
                    //last step will be handled by finished.fu.wizard
                    if (currentStep == 5) {
                        currentStep = 1000;
                    }
                }
                //last step will be handled by finished.fu.wizard
                if (currentStep == 6) {
                    currentStep = 1000;
                }
                switch (currentStep) {
                    case 1:
                        _this.isStepOneActive = true;
                        //set the temp object for the next step
                        if (_this._isStepDataValid(data.step)) {
                            if (_this._hasStepDataChanged(data.step)) {
                                if (_this.currentJobStatus == 'DRAFT' && !_this.job.id) {
                                    _this.createRequisitionWithouFile(function () {
                                        _this.setDataAfterStep1Saved(data);
                                    }, function (error) {
                                        evt.preventDefault();
                                    });
                                }
                                else {
                                    if (_this.currentJobStatus == 'DRAFT') {
                                        _this._saveStep1(false, function () {
                                            _this.setDataAfterStep1Saved(data);
                                        }, function (error) {
                                            evt.preventDefault();
                                        });
                                    }
                                    else {
                                        evt.preventDefault();
                                        _this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, function () {
                                            _this._saveStep1(true, function () {
                                                _this.setDataAfterStep1Saved(data);
                                                // this.reRunResumeScore(null, () => {});
                                                $("#uploadReqWizard").wizard('next');
                                                _this.isRecalcucateScoreNoClicked = false;
                                            }, function (error) {
                                                evt.preventDefault();
                                            });
                                        }, function () {
                                            _this._saveStep1(false, function () {
                                                _this.setDataAfterStep1Saved(data);
                                                $("#uploadReqWizard").wizard('next');
                                                _this.isRecalcucateScoreNoClicked = true;
                                            }, function () {
                                                evt.preventDefault();
                                            });
                                        });
                                    }
                                }
                            }
                            else {
                                if (_this.isRecalcucateScoreNoClicked) {
                                    _this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, function () {
                                        _this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', function () { });
                                    }, function () {
                                        _this.isRecalcucateScoreNoClicked = true;
                                    });
                                }
                            }
                        }
                        else {
                            _this.$timeout(function () {
                                _this.forms.step1Form.$submitted = true;
                                _this.step1Error.hasErrorFlag = true;
                                _this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                            }, 100);
                            // prevent the move. Validation errors will show up.
                            evt.preventDefault();
                        }
                        break;
                    case 2:
                        _this.isStepOneActive = false;
                        if (_this.step2RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            _this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            // there was no step2 request or save in progress. the event was triggered by user click of next button
                            if (_this._isStepDataValid(data.step)) {
                                if (_this._hasStepDataChanged(data.step)) {
                                    if (_this._hasRecruitersBeingUnAssigned() || _this._hasVendorsBeingUnAssigned()) {
                                        evt.preventDefault();
                                        if (_this._hasRecruitersBeingUnAssigned() && _this._hasVendorsBeingUnAssigned()) {
                                            // show both warnings
                                            var warningMessage = _this._getAssignedRecruitersWarningMessage();
                                            warningMessage = warningMessage + "<br><br>" + _this._getVendorsRemovedWarningMessage();
                                            _this._showWarningMessage(warningMessage, function () {
                                                _this._saveStep2AndMoveToNextStep('NEXT');
                                            }, function () {
                                                _this.job.vendorIds = angular.copy(_this.step2DetailsTempObject.vendorIds);
                                                _this._setBuVendors();
                                                _this.job.recruiters = angular.copy(_this.step2DetailsTempObject.recruiters);
                                                _this._setRecruitersAndHiringManagers();
                                            });
                                        }
                                        else if (_this._hasVendorsBeingUnAssigned()) {
                                            _this._showVendorsRemovedWarning(function () {
                                                _this._saveStep2AndMoveToNextStep('NEXT');
                                            }, function () {
                                                _this.job.vendorIds = angular.copy(_this.step2DetailsTempObject.vendorIds);
                                                _this._setBuVendors();
                                            });
                                        }
                                        else {
                                            _this._showRecruitersUnAssignedWarning(function () {
                                                _this._saveStep2AndMoveToNextStep('NEXT');
                                            }, function () {
                                                _this.job.recruiters = angular.copy(_this.step2DetailsTempObject.recruiters);
                                                _this._setRecruitersAndHiringManagers();
                                            });
                                        }
                                    }
                                    else {
                                        _this.step2RequestWasInProgressFlag = true;
                                        _this.utilityService.showLoadingModal("Saving...");
                                        _this.saveStep2Details('NEXT', function () {
                                            // if this is not edit mode and if workflow steps were not already saved, get license preferences
                                            if (!(_this.editModeFlag && _this.workflowStepsSavedFlag) || (_this.hasClientOrBuChanged || _this.hasJobTypeChanged)) {
                                                _this.getAllTechAssessments(function () {
                                                    _this.getAllValueAssessments(function () {
                                                        _this.getLicensePreferences(function () {
                                                            _this._createStepTempObject(data.step + 1);
                                                            _this._createStepTempObject(data.step + 2);
                                                            _this._createWorkflowSliders(function () {
                                                                _this._massageWorkflowStepsOrder();
                                                                _this.hasClientOrBuChanged = false;
                                                                _this.hasJobTypeChanged = false;
                                                            });
                                                            // move to next step as the saves and gets are done.
                                                            _this.utilityService.hideLoadingModal();
                                                            $("#uploadReqWizard").wizard('next');
                                                        }, function () {
                                                            _this.utilityService.hideLoadingModal();
                                                            _this._enableStepActionsOnWizard(data.step);
                                                            //do nothing. error message will show up. no move to next step.
                                                        });
                                                    });
                                                });
                                            }
                                            else {
                                                // move to next step as the save is done.
                                                _this.utilityService.hideLoadingModal();
                                                $("#uploadReqWizard").wizard('next');
                                            }
                                        }, function (error) {
                                            _this.utilityService.hideLoadingModal();
                                            _this._enableStepActionsOnWizard(data.step);
                                            // show error messages
                                            if (_this.$rootScope.isOnline) {
                                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                            }
                                            // no move to next step.
                                        });
                                    }
                                }
                                else {
                                    // if this is not edit mode and if workflow steps were not already saved, get license preferences
                                    if (!(_this.editModeFlag && _this.workflowStepsSavedFlag) || (_this.hasClientOrBuChanged || _this.hasJobTypeChanged)) {
                                        _this.step2RequestWasInProgressFlag = true;
                                        _this.getAllTechAssessments(function () {
                                            _this.getAllValueAssessments(function () {
                                                _this.getLicensePreferences(function () {
                                                    _this._createStepTempObject(data.step + 1);
                                                    _this._createStepTempObject(data.step + 2);
                                                    _this._createWorkflowSliders(function () {
                                                        _this._massageWorkflowStepsOrder();
                                                        _this.hasClientOrBuChanged = false;
                                                        _this.hasJobTypeChanged = false;
                                                    });
                                                    // move to next step as the gets are done.
                                                    $("#uploadReqWizard").wizard('next');
                                                }, function () {
                                                    _this._enableStepActionsOnWizard(data.step);
                                                    //do nothing. error message will show up. no move to next step.
                                                });
                                            });
                                        });
                                    }
                                    else {
                                        // step data valid and not add mode
                                        _this._createStepTempObject(data.step + 1);
                                        _this._createStepTempObject(data.step + 2);
                                    }
                                }
                            }
                            else {
                                _this.$timeout(function () {
                                    _this.forms.step2Form.$submitted = true;
                                    _this.step2Error.hasErrorFlag = true;
                                    _this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                                }, 100);
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (_this.step2RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                _this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 3:
                        if (_this.step3RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            // this.step3RequestWasInProgressFlag = false;
                            // this.disableAllButtonsFlag = false;
                            _this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            _this._parseWorkflowStepsOrderBeforeSave();
                            if (_this._isStepDataValid(data.step)) {
                                if (_this._hasStepDataChanged(data.step)) {
                                    if (_this.currentJobStatus == 'DRAFT') {
                                        _this._updateDataAfterWorkflowStepsSavedNextClicked(false, data, function () {
                                            $("#uploadReqWizard").wizard('next');
                                        }, function () { });
                                    }
                                    else {
                                        if (_this.hasMatchingMandatoryCriteriaChanged() || _this.hasMissingPreferenceDetailsChanged()) {
                                            _this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, function () {
                                                _this._updateDataAfterWorkflowStepsSavedNextClicked(true, data, function () {
                                                    // this.reRunResumeScore(null, () => { });
                                                    // $("#uploadReqWizard").wizard('next');
                                                }, function () { });
                                            }, function () {
                                                _this._updateDataAfterWorkflowStepsSavedNextClicked(false, data, function () {
                                                    // $("#uploadReqWizard").wizard('next');
                                                    _this.isRecalcucateScoreNoClicked = true;
                                                }, function () { });
                                            });
                                        }
                                        else {
                                            _this._updateDataAfterWorkflowStepsSavedNextClicked(false, data, function () {
                                                $("#uploadReqWizard").wizard('next');
                                            }, function () { });
                                        }
                                    }
                                }
                                else {
                                    _this.step3RequestWasInProgressFlag = true;
                                    _this.utilityService.showLoadingModal("Loading...");
                                    _this.getJobBoardParameters(function () {
                                        _this.getRadiusAndRecencyOptions(function () {
                                            _this._createStepTempObject(data.step + 1);
                                            $("#uploadReqWizard").wizard('next');
                                            _this.utilityService.hideLoadingModal();
                                        }, function (error) {
                                            _this._enableStepActionsOnWizard(data.step);
                                            _this.utilityService.hideLoadingModal();
                                            //do nothing. error message will show up. no move to next step.
                                        });
                                    }, function () {
                                        _this._enableStepActionsOnWizard(data.step);
                                        _this.utilityService.hideLoadingModal();
                                        //do nothing. error message will show up. no move to next step.
                                    });
                                }
                            }
                            else {
                                _this.$timeout(function () {
                                    _this.forms.step3Form.$submitted = true;
                                    //check all the values one by one.
                                    _this.step3Error.hasErrorFlag = true;
                                    _this.step3Error.errorMessage = 'Please enter all mandatory fields.';
                                }, 100);
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (_this.step3RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                _this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 4:
                        if (_this.step4RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            _this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            if (_this._isStepDataValid(data.step)) {
                                if (_this._hasStepDataChanged(data.step)) {
                                    _this.step4RequestWasInProgressFlag = true;
                                    _this.saveJobBoardsSettings('NEXT', function () {
                                        if (_this.isInitialStateDraft) {
                                            _this.disableNextButtonFlag = _this.isActivateRequisitionEnabled ? false : true;
                                            $("#uploadReqWizard").wizard('next');
                                        }
                                        else {
                                            var successMessage = "";
                                            if (_this.job.isResumePullEnabled && _this.isJobBoardSelected) {
                                                successMessage = successMessage + "Pulling and matching candidates from job boards";
                                                _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'info');
                                            }
                                            // }
                                            _this._pullResumesAndGetCandidateCountInOpen();
                                        }
                                    }, function (error) {
                                        _this._enableStepActionsOnWizard(data.step);
                                        // show error messages
                                        if (_this.$rootScope.isOnline) {
                                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                        }
                                        // no move to next step
                                    });
                                }
                                else {
                                    _this.step4RequestWasInProgressFlag = true;
                                    // the current job might not have been saved in Open state yet (if it is an edit of a draft job).
                                    if (_this.isInitialStateDraft) {
                                        //will be enabled when activate requisition chosen
                                        _this.$timeout(function () {
                                            $("#uploadReqWizard").wizard('next');
                                        }, 100);
                                        _this.disableNextButtonFlag = _this.isActivateRequisitionEnabled ? false : true;
                                    }
                                    else {
                                        var successMessage = "";
                                        if (_this.job.isResumePullEnabled && _this.isJobBoardSelected) {
                                            successMessage = successMessage + "Pulling and matching candidates from job boards";
                                            _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'info');
                                        }
                                        _this._pullResumesAndGetCandidateCountInOpen();
                                    }
                                }
                            }
                            else {
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (_this.step4RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                _this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 5:
                        if (_this.step5RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            // this.step5RequestWasInProgressFlag = false;
                            // this.disableAllButtonsFlag = false;
                            _this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            if (_this.currentJobStatus == 'DRAFT') {
                                _this.step5RequestWasInProgressFlag = true;
                                _this._setJobStateToOpenAndRunForScoring(function () {
                                    var message = "Requisition activation process has started in the background and will inform all users on the Requisition when its completed.";
                                    _this.alertsAndNotificationsService.showAlertWithCallBack("Requisition Activation", message, "success", function () {
                                        _this.$state.go('missioncontrol.requisitions');
                                    });
                                }, function () { });
                                if (_this.step5RequestWasInProgressFlag) {
                                    // prevent default move.
                                    evt.preventDefault();
                                    _this.disableAllButtonsFlag = true;
                                }
                            }
                        }
                        break;
                    case 6:
                        if (_this.step6RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            _this._enableStepActionsOnWizard(currentStep);
                        }
                        else {
                            if (_this._hasStepDataChanged(currentStep) || _this.isWorkFlowStep4Dot5ScoreChanged) {
                                _this.step6RequestWasInProgressFlag = true;
                                var adjustedScore = $('.slider-adjust-4dot5-score').val();
                                // need to save adjusted score as the current 4dot5 intelligence score
                                _this.saveAdjusted4dot5Score(adjustedScore, function (data) {
                                    _this.sendOutreachEmailToCandidates(data.candidatesToMatch);
                                    _this.isWorkFlowStep4Dot5ScoreChanged = false;
                                    // move to next step as the save is done.
                                    $("#uploadReqWizard").wizard('next');
                                }, function (error) {
                                });
                            }
                            else {
                                _this.sendOutreachEmailToCandidates(_this.currentScoreCandidateCounts.candidatesToMatch);
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (_this.step6RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                _this.disableAllButtonsFlag = true;
                            }
                        }
                        if (_this.isRecalcucateScoreNoClicked) {
                            _this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', function () { });
                        }
                        break;
                    default:
                        break;
                }
            }
            else if (data.direction == "previous") {
                if (data.step == 6)
                    data.step = 5;
                switch (data.step) {
                    case 1:
                        _this.isStepOneActive = true;
                        // not possible
                        break;
                    case 2:
                        _this.isStepOneActive = false;
                        break;
                    case 3:
                        _this._createStepTempObject(data.step - 1);
                        break;
                    case 4:
                        _this._createStepTempObject(data.step - 1);
                        break;
                    case 5:
                        _this.disableNextButtonFlag = false;
                        break;
                    case 6:
                        _this._createStepTempObject(data.step - 1);
                        break;
                    default:
                        break;
                }
            }
        });
        $('#uploadReqWizard').on('finished.fu.wizard', function (evt) {
            var currentStep = 6;
            if (_this.step6RequestWasInProgressFlag) {
                // save or request was in progress and it is now completed. The success has has triggered a next event.
                // set the flag, do nothing and move to next step.
                _this._enableStepActionsOnWizard(currentStep);
            }
            else {
                if (_this._hasStepDataChanged(currentStep) || _this.isWorkFlowStep4Dot5ScoreChanged) {
                    _this.step6RequestWasInProgressFlag = true;
                    var adjustedScore = $('.slider-adjust-4dot5-score').val();
                    //setting to avoid Unsaved data pop up when navigating to requisitions screen
                    _this.isInitialStateDraft = false;
                    // need to save adjusted score as the current 4dot5 intelligence score
                    _this.saveAdjusted4dot5Score(adjustedScore, function (data) {
                        _this.sendOutreachEmailToCandidates(data.candidatesToMatch);
                        _this.isWorkFlowStep4Dot5ScoreChanged = false;
                        //go to requisitions screen
                        _this.$state.go('missioncontrol.requisitions');
                    }, function (error) {
                    });
                }
                else {
                    //setting to avoid Unsaved data pop up when navigating to requisitions screen
                    _this.isInitialStateDraft = false;
                    _this.sendOutreachEmailToCandidates(_this.currentScoreCandidateCounts.candidatesToMatch);
                    _this.$state.go('missioncontrol.requisitions');
                }
                // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                if (_this.step6RequestWasInProgressFlag) {
                    // prevent default move.
                    evt.preventDefault();
                    _this.disableAllButtonsFlag = true;
                }
            }
            if (_this.isRecalcucateScoreNoClicked) {
                _this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', function () { });
            }
        });
        $('#uploadReqWizard').on('changed.fu.wizard', function (evt, data) {
            switch (data.step) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    _this.updateActionButtons();
                    break;
            }
        });
    };
    UploadReqPageController.prototype.setJDActionsValues = function (actionWord, key, fallbackKey) {
        if (fallbackKey === void 0) { fallbackKey = "value"; }
        return actionWord[key] ? actionWord[key][fallbackKey] : "";
    };
    UploadReqPageController.prototype.setJDActionWords = function () {
        var _this = this;
        this.allExistingJDActionWords.forEach(function (jdAction) {
            if (jdAction.jobDescriptionLanguageDropdown && jdAction.jobDescriptionLanguageDropdown.length > 0) {
                jdAction.jobDescriptionLanguageDropdown.forEach(function (actionWord) {
                    var actionWordTemp = { name: actionWord, jdAction: jdAction };
                    _this.allUpdatedJDActionWords.push(actionWordTemp);
                });
            }
        });
        var prepositions = [" in ", " with ", " of ", " at "];
        this.allUpdatedJDActionWords.forEach(function (actionWord) {
            prepositions.forEach(function (preposition) {
                _this.skillsTimePeriods.push({
                    name: "" + actionWord.name + preposition,
                    value: {
                        minExperienceInMonths: _this.setJDActionsValues(actionWord.jdAction, 'minExperienceInMonths'),
                        maxExperienceInMonths: _this.setJDActionsValues(actionWord.jdAction, 'maxExperienceInMonths'),
                        plusTo: _this.setJDActionsValues(actionWord.jdAction, "minExperienceInMonths", "sign"),
                        months: 0,
                        range: "",
                        isJDActionWord: true,
                        jdAction: actionWord
                    }
                });
            });
        });
    };
    UploadReqPageController.prototype.setTimePeriodsForTypeAhead = function () {
        var _this = this;
        this.timePeriods = this.manageSkillsService.setTimePeriodsInRequisitionSkillsTypeAhead();
        this.skillsTimePeriods = [];
        var timePeriodsWithExperience = [];
        this.timePeriods.forEach(function (skill) {
            var tempSkill = tslib_1.__assign({}, skill);
            _this.skillsTimePeriods.push(tempSkill);
            var experienceInSkill = tslib_1.__assign({}, skill, { name: skill.name + 'experience in ' });
            _this.skillsTimePeriods.push(experienceInSkill);
            var experienceWithSkill = tslib_1.__assign({}, skill, { name: skill.name + 'experience with ' });
            _this.skillsTimePeriods.push(experienceWithSkill);
            var experienceOfSkill = tslib_1.__assign({}, skill, { name: skill.name + 'experience of ' });
            _this.skillsTimePeriods.push(experienceOfSkill);
            var experienceSkill = tslib_1.__assign({}, skill, { name: skill.name + 'experience ' });
            timePeriodsWithExperience.push(experienceSkill);
        });
        this.setJDActionWords();
        this.timePeriods = tslib_1.__spread(this.timePeriods, timePeriodsWithExperience);
    };
    UploadReqPageController.prototype.getAllMasterLists = function (successCallback) {
        var _this = this;
        this.isLoading = true;
        var completedRequests = 0;
        var totalRequests = 6;
        var checkCompletion = function () {
            completedRequests++;
            if (completedRequests === totalRequests) {
                setTimeout(function () {
                    _this.setTimePeriodsForTypeAhead();
                }, 50);
                setTimeout(function () {
                    _this.isLoading = false;
                    if (successCallback) {
                        successCallback();
                    }
                }, 100);
            }
        };
        this.getAllSkills(function () { return checkCompletion(); });
        this.getDegreesEntities(function () { return checkCompletion(); });
        this.getFieldOfStudyEntities(function () { return checkCompletion(); });
        this.getRoles(function () { return checkCompletion(); });
        this.getCertificates(function () { return checkCompletion(); });
        this.getJdActions(function () { return checkCompletion(); });
    };
    UploadReqPageController.prototype.getAllSkills = function (successCallback) {
        var _this = this;
        var filterObject = {
            searchSkill: '',
            searchByParentSkill: '',
            searchCategory: '',
            sortColumn: 'skill',
            sortDir: 'ASC',
            includeAlternateSkills: false
        };
        this.allExistingSkills = [];
        this.jobService.getAllSkills(filterObject, function (data) {
            _this.allExistingSkills = data ? data.allSkills.filter(function (skill) { return skill; }) : [];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getDegreesEntities = function (successCallback) {
        var _this = this;
        var degreeFilerObj = {
            searchDegree: '',
            sortColumn: '',
            sortDir: ''
        };
        this.allExistingDegrees = [];
        this.manageSkillsService.getAllDegreesEntityLists(degreeFilerObj, function (data) {
            _this.allExistingDegrees = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getFieldOfStudyEntities = function (successCallback) {
        var _this = this;
        var fieldOfStudyObj = {
            searchFieldOfStudy: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllFieldOfStudyLists(fieldOfStudyObj, function (data) {
            _this.allExistingFieldOfStudy = [];
            _this.allExistingFieldOfStudy = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getRoles = function (successCallback) {
        var _this = this;
        var roleObj = {
            searchRole: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllCandidateRolesLists(roleObj, function (data) {
            _this.allExistingRoles = [];
            _this.allExistingRoles = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getCertificates = function (successCallback) {
        var _this = this;
        var certificatesObj = {
            searchName: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllCertificationsLists(certificatesObj, function (data) {
            _this.allExistingCertificates = [];
            _this.allExistingCertificates = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getJdActions = function (successCallback) {
        var _this = this;
        var jdActionsObj = {
            searchName: '',
            sortColumn: '',
            sortDir: ''
        };
        this.manageSkillsService.getAllJdActionsLists(jdActionsObj, function (data) {
            _this.allExistingJDActionWords = [];
            _this.allExistingJDActionWords = data ? data.allEntities : [];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.updateRequisitionDetails = function () {
        if (!this.isUploadRequisition) {
            this.disableSaveButtonFlag = false;
            if (this.isCorporate || (this.req.clientOrBU && this.req.clientOrBU.id)) {
                this.disableNextButtonFlag = false;
            }
            else {
                this.disableNextButtonFlag = true;
            }
            if (this.step1Error.hasErrorFlag) {
                this.step1Error.errorMessage = 'Please enter all mandatory fields.';
            }
        }
        else {
            this.disableSaveButtonFlag = true;
            this.disableNextButtonFlag = true;
            if (this.step1Error.hasErrorFlag) {
                this.step1Error.errorMessage = '';
            }
        }
    };
    UploadReqPageController.prototype._getFileName = function (requisition) {
        if (requisition.jobRequisitionList[0].originalRequisitionName != null) {
            return requisition.jobRequisitionList[0].originalRequisitionName;
        }
        else {
            if (requisition.jobRequisitionList[0].fileName) {
                var fileName = requisition.jobRequisitionList[0].fileName;
                for (var i = 0; i < 2; i++) {
                    var index = fileName.indexOf('-');
                    fileName = fileName.substring(index + 1);
                }
                return fileName;
            }
            else {
                return null;
            }
        }
    };
    UploadReqPageController.prototype._hasRecruitersBeingUnAssigned = function () {
        return this.step2DetailsTempObject.recruiters.length > this.job.recruiters.length;
    };
    UploadReqPageController.prototype._hasVendorsBeingUnAssigned = function () {
        return this.step2DetailsTempObject.vendorIds.length > this.job.vendorIds.length;
    };
    UploadReqPageController.prototype._saveStep1 = function (isRerun, successCallback, errorCallback) {
        var _this = this;
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.requisitionSkillsLoading = true;
        this.saveStep1Details(isRerun, function () {
            _this.disableAllButtonsFlag = false;
            _this.savingFlag = false;
            _this.requisitionSkillsLoading = false;
            _this._createStepTempObject(1);
            _this.isSkillsChanged = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.disableAllButtonsFlag = false;
            _this.savingFlag = false;
            _this.requisitionSkillsLoading = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    UploadReqPageController.prototype._saveStep2 = function (buttonType) {
        var _this = this;
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveStep2Details(buttonType, function () {
            _this.utilityService.hideLoadingModal();
            _this.disableAllButtonsFlag = false;
            _this.savingFlag = false;
            if (_this.$rootScope.isOnline) {
                var successMessage = 'The Requisition details have been saved in Draft Status.';
                if (_this.currentJobStatus == 'OPEN') {
                    successMessage = 'The Requisition details have been saved.';
                }
                _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
            }
            _this._createStepTempObject(2);
        }, function (error) {
            _this.disableAllButtonsFlag = false;
            _this.savingFlag = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype._saveStep2AndMoveToNextStep = function (buttonType) {
        var _this = this;
        this.step2RequestWasInProgressFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveStep2Details(buttonType, function () {
            // if this is not edit mode and if workflow steps were not already saved, get license preferences
            if ((!(_this.editModeFlag) && !(_this.workflowStepsSavedFlag)) || (_this.hasClientOrBuChanged)) {
                _this.getAllTechAssessments(function () {
                    _this.getAllValueAssessments(function () {
                        _this.getLicensePreferences(function () {
                            _this._createStepTempObject(data.step + 1);
                            _this._createStepTempObject(data.step + 2);
                            _this._createWorkflowSliders(function () {
                                _this._massageWorkflowStepsOrder();
                                _this.hasClientOrBuChanged = false;
                            });
                            // move to next step as the saves and gets are done.
                            _this.utilityService.hideLoadingModal();
                            $("#uploadReqWizard").wizard('next');
                        }, function () {
                            _this.utilityService.hideLoadingModal();
                            _this._enableStepActionsOnWizard(data.step);
                            //do nothing. error message will show up. no move to next step.
                        });
                    });
                });
            }
            else {
                _this.utilityService.hideLoadingModal();
                // move to next step as the save is done.
                $("#uploadReqWizard").wizard('next');
            }
        }, function (error) {
            _this.utilityService.hideLoadingModal();
            _this._enableStepActionsOnWizard(data.step);
            // show error messages
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            // no move to next step.
        });
    };
    UploadReqPageController.prototype._showRecruitersUnAssignedWarning = function (saveCallback, cancelCallback) {
        var warningMessage = this._getAssignedRecruitersWarningMessage();
        this._showWarningMessage(warningMessage, function () {
            saveCallback();
        }, function () {
            cancelCallback();
        });
    };
    UploadReqPageController.prototype._getAssignedRecruitersWarningMessage = function () {
        var _this = this;
        var removedRecruiterIds = _.difference(this.step2DetailsTempObject.recruiters, this.job.recruiters);
        console.log(removedRecruiterIds);
        var recruiterNames = [];
        angular.forEach(removedRecruiterIds, function (recruiterId, recruiterIdIndex) {
            angular.forEach(_this.recruiterList, function (recruiter, recruiterIndex) {
                if (recruiterId == recruiter.userId) {
                    recruiterNames.push(recruiter.firstName + recruiter.lastName);
                }
            });
        });
        var message = "<b>";
        var totalCount = recruiterNames.length;
        angular.forEach(recruiterNames, function (name, index) {
            if (index == totalCount - 1) {
                message = message + name;
            }
            else if (index == totalCount - 2) {
                message = message + name + " & ";
            }
            else {
                message = message + name + ", ";
            }
        });
        var messageEnd = totalCount > 1 ? "</b> shall be removed as assigned recruiters from all the candidates in the requisition. " : "</b> shall be removed as assigned recruiter from all the candidates in the requisition. ";
        return message + messageEnd;
    };
    UploadReqPageController.prototype._showVendorsRemovedWarning = function (saveCallback, cancelCallback) {
        var warningMessage = this._getVendorsRemovedWarningMessage();
        this._showWarningMessage(warningMessage, function () {
            saveCallback();
        }, function () {
            cancelCallback();
        });
    };
    UploadReqPageController.prototype._getVendorsRemovedWarningMessage = function () {
        var _this = this;
        var removedVendorIds = _.difference(this.step2DetailsTempObject.vendorIds, this.job.vendorIds);
        console.log(removedVendorIds);
        var vendorNames = [];
        angular.forEach(removedVendorIds, function (vendorId, vendorIdIndex) {
            angular.forEach(_this.vendorsList, function (vendor, vendorIndex) {
                if (vendorId == vendor.vendorId) {
                    vendorNames.push(vendor.vendorName);
                }
            });
        });
        var message = "All the candidates, if any, related to <b>";
        var totalCount = vendorNames.length;
        angular.forEach(vendorNames, function (name, index) {
            if (index == totalCount - 1) {
                message = message + name;
            }
            else if (index == totalCount - 2) {
                message = message + name + " & ";
            }
            else {
                message = message + name + ", ";
            }
        });
        var messageEnd = totalCount > 1 ? "</b> vendors will be released. " : "</b> vendor will be released. ";
        return message + messageEnd;
    };
    UploadReqPageController.prototype._showWarningMessage = function (warningMessage, saveCallback, cancelCallback) {
        warningMessage = warningMessage + '<br>Do you still want to continue?';
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: warningMessage,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    saveCallback();
                }
                else {
                    cancelCallback();
                }
            }
        });
    };
    UploadReqPageController.prototype.getPlanDetails = function (successCallback) {
        var _this = this;
        this.planService.getCompanyPlanDetails(this.companyId, function (data) {
            if (!_.isNull(data)) {
                if (data !== "" && !_.isNull(data.features) && data.features.length) {
                    var jobIntegrationDetails = _.find(data.features, { 'name': "Job Board Integration", 'available': true });
                    _this.isJobIntegrationEnabledByPlan = _.isUndefined(jobIntegrationDetails) ? false : true;
                    if (!_this.isJobIntegrationEnabledByPlan) {
                        _this.isResumePullEnabled = false;
                    }
                    _this.isTrialPlanActive = data.plan == "Trial" ? true : false;
                    successCallback();
                }
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype._massageWorkflowStepsOrder = function () {
        var _this = this;
        var jobType = _.filter(this.jobTypeList, function (jobType) {
            return jobType.value == _this.job.jobType;
        });
        if (jobType.length > 0) {
            this.selectedJobType = jobType[0].name;
            this._setJobType();
        }
        this.workflowStepsOrder = angular.copy(this.job.workflowStepsOrder);
        this.isAnyWorkflowStepsEnabled = false;
        //setting id for dnd list to work
        angular.forEach(this.workflowStepsOrder, function (steps, jobType) {
            var stepsDetails = [];
            angular.forEach(steps, function (step, index) {
                var isStepEnabled = true;
                if (step == "Recruiter Screening") {
                    isStepEnabled = _this.job.recruiterScreening && _this.recruiterScreeningPreferences.enabled;
                }
                else if (step == "Tech Assessment") {
                    isStepEnabled = _this.job.techAssessment && _this.techAssessmentPreferences.enabled;
                }
                else if (step == "Value Assessment") {
                    isStepEnabled = _this.job.valueAssessment && _this.valueAssessmentPreferences.enabled;
                }
                else if (step == "Phone Screen") {
                    isStepEnabled = _this.job.phoneScreen && _this.phoneScreenPreferences.enabled;
                }
                else if (step == "Interview") {
                    isStepEnabled = _this.job.interview && _this.interviewPreferences.enabled;
                }
                if (isStepEnabled) {
                    _this.isAnyWorkflowStepsEnabled = true;
                }
                stepsDetails.push({ id: index, stepName: step, enabled: isStepEnabled, jobType: jobType });
            });
            _this.workflowStepsOrder[jobType] = angular.copy(stepsDetails);
        });
        this.workflowStepsOrderToRender = angular.copy(this.workflowStepsOrder);
        angular.forEach(this.workflowStepsOrderToRender, function (steps, jobType) {
            steps.splice(0, 1);
            steps.splice(steps.length - 1, 1);
        });
    };
    UploadReqPageController.prototype._parseWorkflowStepsOrderBeforeSave = function () {
        var _this = this;
        angular.forEach(this.workflowStepsOrder, function (steps, jobType) {
            var stepDetails = [];
            angular.forEach(steps, function (step, index) {
                if (index !== 0 && index !== steps.length - 1) {
                    stepDetails.push(_this.workflowStepsOrderToRender[jobType][index - 1]);
                }
                else {
                    stepDetails.push(step);
                }
            });
            _this.workflowStepsOrder[jobType] = angular.copy(stepDetails);
        });
        var workflowStepsOrderCopy = angular.copy(this.workflowStepsOrder);
        angular.forEach(this.workflowStepsOrder, function (steps, jobType) {
            var stepsDetails = [];
            angular.forEach(steps, function (step, index) {
                stepsDetails.push(step.stepName);
            });
            workflowStepsOrderCopy[jobType] = angular.copy(stepsDetails);
        });
        this.job.workflowStepsOrder = angular.copy(workflowStepsOrderCopy);
    };
    UploadReqPageController.prototype.stepMoved = function ($index, jobType) {
        this.workflowStepsOrderToRender[jobType].splice($index, 1);
    };
    UploadReqPageController.prototype.getSalaryDurationOptions = function () {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.allSalaryDurationOptions = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getCurrencyCodes = function () {
        var _this = this;
        this.jobService.getCurrencyCodes(function (data) {
            _this.currencyCodes = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.checkJobBoardsSearchAvailability = function () {
        var _this = this;
        this.jobService.checkJobBoardsSearchAvailability(function (data) {
            _this.isJobBoardServiceUp = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype._checkIfOutreachEnabled = function () {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    };
    UploadReqPageController.prototype.getJobBoardsResumePullLimits = function () {
        var _this = this;
        this.planService.getAvailableJobBoardsPullCount(this.companyId, function (data) {
            _this.jobBoardsResumePullLeft = data["jobBoardResumesLeftCount"];
            _this.jobBoardsPullResumePulled = data["jobBoardResumesPulledCount"];
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getJobBoardParameters = function (successCallback, errorCallback) {
        var _this = this;
        this.jobService.getJobBoardParameters(function (data) {
            _this.jobBoardParameters = data;
            _this.parseJobBoardParameters();
            successCallback(data);
        }, function (error) {
            errorCallback();
        });
    };
    UploadReqPageController.prototype.getJobBoardsSearchJobStatus = function (successCallback, errorCallback) {
        this.jobService.getGetMoreResumesJobStatus(this.job.id, function (jobInProgress) {
            successCallback(jobInProgress);
        }, function (error) {
            errorCallback(error);
        });
    };
    UploadReqPageController.prototype.parseJobBoardParameters = function () {
        var _this = this;
        angular.forEach(this.job.jobBoardDetails, function (val, key) {
            if (!_.isNull(val.daxtraCode)) {
                var flags = [];
                var jobBoardsParams = _this.jobBoardParameters.jobBoardParameterMap[val.daxtraCode];
                flags.push(true); // location supported by all job boards
                flags.push(_this._isParameterSupported(jobBoardsParams, "postcode"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "radius"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "jobType"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "recency"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "education"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "industry"));
                flags.push(_this._isParameterSupported(jobBoardsParams, "salary"));
                val.flags = flags;
            }
        });
        this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
        this.jobBoardsSettingsTempObject.jobBoardDetails = angular.copy(this.job.jobBoardDetails);
    };
    UploadReqPageController.prototype._isParameterSupported = function (jobBoardParameters, parameter) {
        return (jobBoardParameters.indexOf(parameter) == -1) ? false : true;
    };
    UploadReqPageController.prototype.getRadiusAndRecencyOptions = function (successCallback, errorCallback) {
        var _this = this;
        this.jobService.getRadiusAndRecencyOptions(function (data) {
            // console.log('options');
            // console.log(data);
            _this.radiusOptions = data.radius;
            _this.recencyOptions = data.recency;
            if (_.isNull(_this.job.radius)) {
                _this.job.radius = data.defaultRadius[0];
                _this.isJobBoardDetailsSet = false;
            }
            if (_.isNull(_this.job.recency)) {
                _this.job.recency = data.defaultRecency[0];
            }
            successCallback(data);
        }, function (error) {
            errorCallback();
        });
    };
    /**
     * creates the requisition upload drop zone.
     */
    UploadReqPageController.prototype.createReqUploadDropzone = function () {
        var _this = this;
        var reqUploadDropzone = new Dropzone("form#reqUploadDropzone", {
            url: this.requisitionService.getUploadUrl(),
            paramName: "file",
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: 1,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            addRemoveLinks: true,
            autoProcessQueue: false,
            clickable: this.isFileUploadEnabled,
            timeout: 300000,
        });
        // add event handlers for the drop zone
        reqUploadDropzone.on('addedfile', function (file, response) {
            _this.fileExistsFlag = true;
            _this.updateActionButtons();
            // set the progress bar so that it is properly visible
            $('.dz-progress').css({ top: '70%' });
        });
        reqUploadDropzone.on('removedfile', function (file, response) {
            _this.fileExistsFlag = false;
            _this.isClientOrBuDisabled = false;
            //reset the job object
            _this.job = new Job();
            _this.updateActionButtons();
            // Edit requisition Details
            _this.isEditRequisitionDetails = false;
        });
        reqUploadDropzone.on('sending', function (file, xhr, formData) {
            // disable the upload button to avoid multiple clicks
            _this.disableUploadButtonFlag = true;
            _this.isClientOrBuDisabled = true;
            // indicate that file upload is in progress
            _this.fileUploadInProgressFlag = true;
            formData.append('companyId', _this.userDetails.company.companyId);
            formData.append('isSharedClientRequisition', _this.req.isSharedClientRequisition);
            if (_this.req.clientOrBU) {
                formData.append('buId', _this.req.clientOrBU.id);
            }
            if (_this.req.sharedClientBuOrCorpId !== null) {
                formData.append('sharedClientBuOrCorpId', _this.req.sharedClientBuOrCorpId);
            }
            formData.append('userId', _this.userDetails.id);
        });
        reqUploadDropzone.on('success', function (file, response) {
            // remove file upload in progress flag
            _this.fileUploadInProgressFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.UPLOAD_SUCCESS, 'success');
            // merge the response into the job object
            _this.job = _this._parseJobResponse(response);
            _this._setSponsorshipSelectedDefault(false);
            _this._createStepTempObject(1);
            _this._createStepTempObject(2);
            _this.getAllJobBoards(function () {
                _this._setJobBoardDetails();
            });
            if (!_this.editModeFlag) {
                _this.getRecruiters(function () {
                    _this._setRecruitersAndHiringManagers();
                });
                if (!_this.isCorporate) {
                    _this.getPointOfContacts(function () {
                        _this._setPocs();
                    });
                }
                if (!_this.clientOrBUIsRequiredFlag) {
                    _this.getBuVendors(function () {
                        _this._setBuVendors();
                    });
                }
            }
            // this._massageWorkflowStepsOrder();
            _this.updateActionButtons();
            // Edit requisition Details
            _this.isEditRequisitionDetails = true;
            _this.isUploadRequisition = false;
            _this.isUploadAndEditRadioBtn = false;
        });
        reqUploadDropzone.on("error", function (file, error) {
            var elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, function (element, index) {
                var filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                var errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
        });
        return reqUploadDropzone;
    };
    UploadReqPageController.prototype.getJob = function (jobId, successCallback) {
        var _this = this;
        this.jobService.getJob(jobId, function (data) {
            if (_this.editMcurrentJobStatus != 'DRAFT') {
                // Set requisition icons
                _this.requisitionInfo = _.cloneDeep(data);
                _this.requisitionInfo.workflowSteps = _this.$stateParams.workflowSteps;
                _this.requisitionInfo.fourDotFiveIntelligentThresholdScore = _this.$stateParams.fourDotFiveIntelligentThresholdScore;
                _this.requisitionInfo.vendorsDetails = _this.$stateParams.vendorsDetails;
                _this.requisitionInfo.autoMatedMatchEnabled = true;
                _this.requisitionInfo.autoMatedMatchSelected = false;
            }
            _this.job = _this._parseJobResponse(data);
            if (data.jobCurrentState == 'COMPLETED' || data.jobCurrentState == 'CANCELED') {
                _this.disableWorkflowSettings = true;
            }
            // this._massageWorkflowStepsOrder();
            successCallback(data);
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype._parseJobResponse = function (data) {
        this.isJobFetched = true;
        var tempJob = new Job();
        tempJob.id = data.id;
        tempJob.title = data.title;
        tempJob.sharedClientBuOrCorpId = data.sharedClientBuOrCorpId;
        tempJob.isSharedClientRequisition = data.isSharedClientRequisition;
        tempJob.company = {
            name: data.company.name,
            id: data.company.id,
            shortName: data.company.shortName
        };
        if (_.isNull(data.clientorbu)) {
            tempJob.clientorbu = null;
        }
        else {
            tempJob.clientorbu = {
                name: data.clientorbu.name,
                id: data.clientorbu.id,
                shortName: data.clientorbu.shortName
            };
        }
        tempJob.requisitionNumber = data.requisitionNumber;
        tempJob.jobType = data.jobType;
        tempJob.contractDuration = data.contractDuration;
        tempJob.requisitionNote = data.requisitionNote;
        tempJob.jobSalary = angular.copy(data.jobSalary);
        tempJob.location = data.location;
        tempJob.locationLabel = '-';
        if (!_.isNull(tempJob.location)) {
            if (!_.isNull(data.location.city)) {
                tempJob.locationLabel = data.location.city;
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.state;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.locationLabel = '-';
                }
            }
            else {
                if (!_.isNull(data.location.state)) {
                    tempJob.locationLabel += ', ' + data.location.state;
                }
            }
            if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel == '-') {
                tempJob.locationLabel = data.location.zipcode ? data.location.zipcode : data.location.zipCode;
                if (_.isNull(tempJob.locationLabel)) {
                    tempJob.zipCode = '-';
                }
            }
            else {
                if (data.location.zipcode || data.location.zipCode) {
                    tempJob.locationLabel += ', ' + (data.location.zipcode ? data.location.zipcode : data.location.zipCode);
                }
            }
        }
        // set the transaction id of the last requisition in the requisition list as job's transaction id
        tempJob.transactionId = data.jobRequisitionList[(data.jobRequisitionList.length - 1)].transactionId;
        tempJob.openings = data.numberOfOpenings;
        tempJob.sponsorships = data.sponsorships;
        tempJob.workLocationIds = data.workLocations ? data.workLocations.map(function (workLocation) { return workLocation.id; }) : [];
        tempJob.workLocations = data.workLocations;
        tempJob.sponsorshipProvided = data.sponsorshipProvided;
        tempJob.recruiters = data.recruiters.map(function (recruiter) {
            return recruiter.id;
        });
        tempJob.hiringManagers = data.hiringManagers.map(function (manager) {
            return { id: manager.user.id, isPrimary: manager.isPrimary };
        });
        if (!_.isNull(data.pointOfContact)) {
            tempJob.pointOfContactUserId = data.pointOfContact.id;
        }
        else {
            tempJob.pointOfContactUserId = null;
        }
        // Set End Client
        tempJob.endClient = data.endClient;
        this._setEndClient(tempJob);
        tempJob.vendorIds = data.vendorIds;
        tempJob.educationList = data.educationList;
        tempJob.score = data.fourDotFiveIntelligenceScore;
        tempJob.licensePreferences = data.licensePreferences;
        this.isLicensePreferenceSet = data.licensePreferences !== null;
        tempJob.radius = data.radius;
        tempJob.recency = data.recency;
        tempJob.salary = data.salary;
        data.location.zipcode = null;
        tempJob.industry = data.industry;
        tempJob.workflowStepsOrder = data.workflowStepsOrder;
        if (!_.isNull(data.techAssessmentId) && this.$stateParams.jobState != 'Completed' && this.$stateParams.jobState != 'Canceled') {
            tempJob.techAssessmentId = data.techAssessmentId;
            tempJob.techAssessmentScore = data.techAssessmentScore;
            this._getSentAssessmentsCount(tempJob.techAssessmentId, 'Technical', tempJob.id);
        }
        if (!_.isNull(data.valueAssessmentId) && this.$stateParams.jobState != 'Completed' && this.$stateParams.jobState != 'Canceled') {
            tempJob.valueAssessmentId = data.valueAssessmentId;
            this._getSentAssessmentsCount(tempJob.valueAssessmentId, 'Value', tempJob.id);
        }
        tempJob.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.jobBoardDetails)) {
            angular.forEach(tempJob.jobBoardDetails, function (val, key) {
                if (_.findIndex(tempJob.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
        }
        this.jobBoardDetailsCopy = angular.copy(tempJob.jobBoardDetails);
        if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.resumesToPullPerJobBoardCount)) {
            tempJob.resumesToPullPerJobBoardCount = data.licensePreferences.resumesToPullPerJobBoardCount;
            this.resumesToPullPerJobBoardCountCopy = tempJob.resumesToPullPerJobBoardCount;
            tempJob.isResumePullEnabled = false;
        }
        tempJob.daxtraParameters = data.daxtraParameters;
        if (!(_.isNull(data.daxtraParameters) || _.isUndefined(data.daxtraParameters)) && !(_.isNull(data.advancedParametersImage) || _.isUndefined(data.advancedParametersImage))) {
            this.activeJobBoardsFilterTabNumber = 1;
        }
        tempJob.advancedParametersImage = this.$sce.trustAsResourceUrl(data.advancedParametersImage);
        tempJob.salaryLabel = "Salary Details";
        if (data.jobType && (data.jobType == 'CONTRACTOR' || data.jobType == 'CONTRACTTOHIRE')) {
            tempJob.salaryLabel = this.isCorporate || tempJob.isSharedClientRequisition ? "Bill Rate" : "Client/Bill Rate";
        }
        tempJob.jobTypeLabel = (data.jobType && this.jobTypeList.length > 0) ? this.jobTypeList.filter(function (jobType) { return jobType.value == data.jobType; })[0].name : null;
        tempJob.requisitionSalaryDisplayMessage = this.requisitionService._getSalaryDetailsDisplayMessage(tempJob.jobSalary ? tempJob.jobSalary : new JobSalary(), this.allSalaryDurationOptions);
        if (_.isNull(tempJob.sponsorshipProvided) || _.isUndefined(tempJob.sponsorshipProvided)) {
            tempJob.sponsorshipsDisplayMessage = "Sponsorship information not specified";
        }
        else if (_.isNull(tempJob.sponsorships) || tempJob.sponsorships.length == 0) {
            tempJob.sponsorshipsDisplayMessage = "Not Available";
        }
        else if (tempJob.sponsorships.length > 0) {
            tempJob.sponsorshipsDisplayMessage = "";
            var message_1 = "";
            angular.forEach(tempJob.sponsorships, function (sponsor, key) {
                if (key == tempJob.sponsorships.length - 1) {
                    message_1 = message_1 + sponsor;
                }
                else if (key == tempJob.sponsorships.length - 2) {
                    message_1 = message_1 + sponsor + " and ";
                }
                else {
                    message_1 = message_1 + sponsor + ", ";
                }
            });
            tempJob.sponsorshipsDisplayMessage = message_1;
        }
        tempJob.profileCriteriaInfo = data.profileCriteriaInfo;
        tempJob.includeCandidatesWithNoAdditionalDetails = data.licensePreferences ? data.licensePreferences.includeCandidatesWithNoAdditionalDetails : false;
        tempJob.includeCandidatesMatchingMandatoryCriteria = data.licensePreferences ? data.licensePreferences.includeCandidatesMatchingMandatoryCriteria : false;
        return tempJob;
    };
    UploadReqPageController.prototype._getSentAssessmentsCount = function (assessmentId, assessmentType, jobId) {
        var _this = this;
        this.jobService.getAssessmentDetails(assessmentId, jobId, function (data) {
            if (assessmentType == 'Technical') {
                _this.sentTechnicalAssessmentsDetail = data;
            }
            else {
                _this.sentValueAssessmentsDetail = data;
            }
        }, function (error) {
        });
    };
    UploadReqPageController.prototype._setJobStateToOpenAndRunForScoring = function (successCallback, errorCallback) {
        var _this = this;
        this.utilityService.showLoadingModal("Saving...");
        this.setJobStatusToOpen(function () {
            _this.currentJobStatus = "OPEN";
            $('.dz-remove').remove();
            _this._pullResumesAndGetCandidateCountInDraft(function () {
                _this.utilityService.hideLoadingModal();
                _this.runJobForScoring(function () { });
                _this._getCandidateCountBeforeStep5(function () {
                    _this._createCountSliders();
                    $('.dz-remove').remove();
                }, function () { });
                if (successCallback) {
                    successCallback();
                }
            }, function () {
                if (errorCallback) {
                    errorCallback();
                }
            });
        }, function () {
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    UploadReqPageController.prototype._pullResumesAndGetCandidateCountInDraft = function (successCallback, errorCallback) {
        var _this = this;
        if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
            this.getJobBoardsSearchJobStatus(function (jobStatus) {
                if (jobStatus == true) {
                    _this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
                    if (successCallback) {
                        successCallback();
                    }
                }
                else {
                    _this.getResumesFromJobBoards(function () {
                        var successMessage = "";
                        if (_this.job.autoMatch) {
                            successMessage = successMessage + "Matched candidates from system ";
                            if (_this.job.isResumePullEnabled && _this.isJobBoardSelected) {
                                successMessage = successMessage + "and pulled and matched candidates from job boards";
                            }
                        }
                        else {
                            if (_this.job.isResumePullEnabled && _this.isJobBoardSelected) {
                                successMessage = successMessage + "Pulled candidates from job board";
                            }
                        }
                        _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                        if (successCallback) {
                            successCallback();
                        }
                    }, function (error) {
                        _this.utilityService.hideLoadingModal();
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        if (errorCallback) {
                            errorCallback();
                        }
                        ;
                    });
                }
            }, function (error) {
                _this.utilityService.hideLoadingModal();
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                if (errorCallback) {
                    errorCallback();
                }
                ;
            });
        }
        else {
            if (successCallback) {
                successCallback();
            }
        }
    };
    UploadReqPageController.prototype._pullResumesAndGetCandidateCountInOpen = function () {
        var _this = this;
        if (this.job.isResumePullEnabled && this.isJobBoardSelected) {
            this.getJobBoardsSearchJobStatus(function (jobStatus) {
                if (jobStatus == true) { //job in progress
                    _this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
                    _this._enableStepActionsOnWizard(data.step);
                }
                else {
                    _this.getResumesFromJobBoards(function () {
                        _this._getCandidateCountBeforeStep5(function () {
                            _this._createCountSliders();
                            var successMessage = "";
                            if (_this.job.autoMatch) {
                                successMessage = successMessage + "Matched candidates from system ";
                                if (_this.job.isResumePullEnabled && _this.isJobBoardSelected) {
                                    successMessage = successMessage + "and pulled and matched candidates from job boards";
                                }
                                _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            }
                            else {
                                if (_this.job.isResumePullEnabled && _this.isJobBoardSelected) {
                                    successMessage = successMessage + "Pulled and matched candidates from job boards";
                                    _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                }
                            }
                            // move to next step as the save is done.
                            $("#uploadReqWizard").wizard('next');
                        }, function () {
                            _this._enableStepActionsOnWizard(data.step);
                            //do nothing. error message will show up. no move to next step.
                        });
                    }, function (error) {
                        //end of resume pull
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        _this._enableStepActionsOnWizard(data.step);
                    });
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                _this._enableStepActionsOnWizard(data.step);
            });
        }
        else {
            this.utilityService.showLoadingModal("Loading...");
            this._getCandidateCountBeforeStep5(function () {
                _this._createCountSliders();
                $("#uploadReqWizard").wizard('next');
                _this.utilityService.hideLoadingModal();
            }, function () {
                _this._enableStepActionsOnWizard(data.step);
                _this.utilityService.hideLoadingModal();
                //do nothing. error message will show up. no move to next step.
            });
        }
    };
    UploadReqPageController.prototype._getCandidateCountBeforeStep5 = function (successCallback, errorCallback) {
        this.getCandidateCount(this.job.score, 'currentScore', function () {
            if (successCallback) {
                successCallback();
            }
        }, function () {
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    UploadReqPageController.prototype._createStepTempObject = function (currentStep) {
        switch (currentStep) {
            case 1:
                var clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
                this.step1DetailsTempObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUIdStepOne,
                    requistionNumber: this.job.requisitionNumber,
                    isFutureMatchesOnly: this.isFutureMatchesOnly,
                    profileCriteriaInfo: _.cloneDeep(this.job.profileCriteriaInfo),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
                };
                break;
            case 2:
                var clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
                this.step2DetailsTempObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.job.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUId,
                    requistionNumber: this.job.requisitionNumber,
                    openings: this.job.openings,
                    jobType: this.job.jobType,
                    contractDuration: this.job.contractDuration,
                    requisitionNote: this.job.requisitionNote,
                    jobSalary: angular.copy(this.job.jobSalary),
                    sponsorships: this.job.sponsorships,
                    sponsorshipProvided: this.job.sponsorshipProvided,
                    workLocationIds: this.job.workLocationIds,
                    recruiters: this.job.recruiters,
                    hiringManagers: angular.copy(this.job.hiringManagers),
                    pointOfContactUserId: angular.copy(this.job.pointOfContactUserId),
                    vendorIds: this.job.vendorIds,
                    salary: this.job.salary,
                    tab: "ASSIGN_RECRUITERS",
                    endClientId: this.job.endClientId
                };
                break;
            case 3:
                this.workflowStepsTempObject = {
                    jobId: this.job.id,
                    score: this.job.score,
                    autoMatch: this.job.autoMatch,
                    recruiterScreening: this.job.recruiterScreening,
                    techAssessmentId: this.job.techAssessmentId,
                    techAssessmentScore: this.job.techAssessmentScore,
                    techAssessment: this.job.techAssessment,
                    valueAssessmentId: this.job.valueAssessmentId,
                    valueAssessment: this.job.valueAssessment,
                    eduVerification: this.job.eduVerification,
                    expVeification: this.job.expVeification,
                    phoneScreen: this.job.phoneScreen,
                    interview: this.job.interview,
                    imageProctoring: this.job.imageProctoring,
                    addProctoringImagesToReport: this.job.addProctoringImagesToReport,
                    workflowStepsOrder: angular.copy(this.job.workflowStepsOrder),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    // jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    // resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    tab: "WORKFLOW_STEPS"
                };
                break;
            case 4:
                this.jobBoardsSettingsTempObject = {
                    // jobId: this.job.id,
                    // autoMatch: this.job.autoMatch,
                    jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    isResumePullEnabled: this.job.isResumePullEnabled,
                    radius: this.job.radius,
                    recency: this.job.recency,
                    tab: "JOB_BOARDS"
                };
                break;
            case 5:
                break;
            case 6:
                break;
            default:
                break;
        }
    };
    UploadReqPageController.prototype._isStepDataValid = function (currentStep) {
        var stepDataValidityFlag = true;
        switch (currentStep) {
            case 1:
                this.forms.step1Form.$submitted = true;
                if (this.req.clientOrBU && this.req.clientOrBU.id && ((this.currentJobStatus == 'DRAFT' && (this.job.title && this.job.title != '')) || this.currentJobStatus != 'DRAFT')) {
                    if (this.req.clientOrBU.companyType === 'Corporation') {
                        if (this.sharedClientBuOrCorp && this.sharedClientBuOrCorp.id) {
                            stepDataValidityFlag = true;
                            this.step1Error.hasErrorFlag = false;
                            this.step1Error.errorMessage = '';
                        }
                        else {
                            stepDataValidityFlag = false;
                            this.step1Error.hasErrorFlag = true;
                            this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                        }
                    }
                    else {
                        stepDataValidityFlag = true;
                        this.step1Error.hasErrorFlag = false;
                        this.step1Error.errorMessage = '';
                    }
                }
                else {
                    if (this.isCorporate && (this.currentJobStatus != 'DRAFT' || (this.currentJobStatus === 'DRAFT' && (this.job.title && this.job.title != '')))) {
                        stepDataValidityFlag = true;
                        this.step1Error.hasErrorFlag = false;
                        this.step1Error.errorMessage = '';
                    }
                    else {
                        stepDataValidityFlag = false;
                        this.step1Error.hasErrorFlag = true;
                        this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                    }
                }
                break;
            case 2:
                // set the form to submitted
                this.forms.step2Form.$submitted = true;
                //check all the values one by one.
                if (this.forms.step2Form.$invalid || (this.job.jobType == null) || (this.job.recruiters.length == 0) || (this.job.sponsorshipProvided && this.job.sponsorships.length == 0) || (this.job.workLocationIds.length == 0) || (this.job.hiringManagers.length > 0 && !this.isPrimaryHiringManagerSelected()) || (this.job.vendorIds.length > 0 && _.isNull(this.job.pointOfContactUserId))) {
                    this.step2Error.hasErrorFlag = true;
                    this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                }
                else {
                    this.step2Error.hasErrorFlag = false;
                    this.step2Error.errorMessage = '';
                }
                break;
            case 3:
                // set the form to submitted
                this.forms.step3Form.$submitted = true;
                //check all the values one by one.
                if (this.forms.step3Form.$invalid) {
                    this.step3Error.hasErrorFlag = true;
                    this.step3Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                }
                else {
                    this.step3Error.hasErrorFlag = false;
                    this.step3Error.errorMessage = '';
                }
                break;
            case 4:
                break;
            default:
                break;
        }
        return stepDataValidityFlag;
    };
    UploadReqPageController.prototype.removeUnusedSkills = function (skills) {
        var skillsArray = [
            'educations',
            'experiences',
            'technicalSkills',
            'operationalSkills',
            'softSkills',
            'otherSkills',
            'certifications'
        ];
        skillsArray.forEach(function (skill) {
            if (skills[skill]) {
                skills[skill] = skills[skill]
                    .filter(function (item) { return item.displayName && item.displayName.trim() !== ''; })
                    .map(function (item) { return (tslib_1.__assign({}, item, { range: !item.range ? "" : (item.displayName && item.displayName.includes(item.range)) ? item.range : "", plusTo: !item.plusTo ? "" : item.plusTo })); });
            }
            else {
                skills[skill] = [];
            }
        });
    };
    UploadReqPageController.prototype.setProfileCriteria = function (obj1, obj2) {
        var newObj = {};
        var keys = Object.keys(obj1);
        keys.forEach(function (key) {
            var val1 = obj1[key];
            var val2 = obj2[key];
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (val1.length !== val2.length) {
                    newObj[key] = val2;
                }
                else {
                    newObj[key] = val1.map(function (item, index) {
                        var newItem = {};
                        var item2 = val2[index] || {};
                        Object.keys(item).forEach(function (subKey) {
                            newItem[subKey] = item2[subKey];
                        });
                        return newItem;
                    });
                }
            }
            else {
                if (!val1) {
                    newObj[key] = val2;
                }
                else if (!val2) {
                    newObj[key] = [];
                }
                else {
                    newObj[key] = val2;
                }
            }
        });
        return newObj;
    };
    UploadReqPageController.prototype._hasStepDataChanged = function (currentStep) {
        var stepDataHasChangedFlag = false;
        switch (currentStep) {
            case 1:
                var clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
                var currentStep1DataObject = {
                    jobId: this.job.id,
                    title: this.job.title,
                    isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUIdStepOne,
                    requistionNumber: this.job.requisitionNumber,
                    isFutureMatchesOnly: this.isFutureMatchesOnly,
                    profileCriteriaInfo: _.cloneDeep(this.job.profileCriteriaInfo),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
                };
                var step1DetailsTempObject = _.cloneDeep(this.step1DetailsTempObject);
                this.removeUnusedSkills(step1DetailsTempObject.profileCriteriaInfo);
                this.removeUnusedSkills(currentStep1DataObject.profileCriteriaInfo);
                currentStep1DataObject.profileCriteriaInfo = this.setProfileCriteria(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
                this.isSkillsChanged = !_.isEqual(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
                stepDataHasChangedFlag = !_.isEqual(step1DetailsTempObject, currentStep1DataObject);
                break;
            case 2:
                var clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
                var currentStep2DataObject = {
                    jobId: this.job.id,
                    isSharedClientRequisition: this.job.isSharedClientRequisition,
                    sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
                    clientOrBUId: clientOrBUId,
                    requistionNumber: this.job.requisitionNumber,
                    openings: this.job.openings,
                    title: this.job.title,
                    jobType: this.job.jobType,
                    contractDuration: this.job.contractDuration,
                    requisitionNote: this.job.requisitionNote,
                    jobSalary: angular.copy(this.job.jobSalary),
                    sponsorships: this.job.sponsorships,
                    sponsorshipProvided: this.job.sponsorshipProvided,
                    workLocationIds: this.job.workLocationIds,
                    recruiters: this.job.recruiters,
                    hiringManagers: angular.copy(this.job.hiringManagers),
                    vendorIds: this.job.vendorIds,
                    pointOfContactUserId: this.job.pointOfContactUserId,
                    salary: this.job.salary,
                    tab: "ASSIGN_RECRUITERS",
                    endClientId: this.job.endClientId
                };
                stepDataHasChangedFlag = !(_.isEqual(this.step2DetailsTempObject, currentStep2DataObject));
                // set hasClientOrBuChanged to true if client or bu changed and save/next clicked
                if (!this.hasClientOrBuChanged) {
                    this.hasClientOrBuChanged = !(_.isEqual(this.step2DetailsTempObject.clientOrBUId, currentStep2DataObject.clientOrBUId));
                }
                if (this.hasClientOrBuChanged || this.isJobLocationChanged) {
                    stepDataHasChangedFlag = true;
                }
                if (!(_.isEqual(this.step2DetailsTempObject.workLocationIds, currentStep2DataObject.workLocationIds)) ||
                    !(_.isEqual(this.step2DetailsTempObject.sponsorships, currentStep2DataObject.sponsorships)) || this.isJobLocationChanged) {
                    this.isAsyncProcess = true;
                }
                break;
            case 3:
                var currentWorkflowStepsObject = {
                    jobId: this.job.id,
                    score: this.job.score,
                    autoMatch: this.job.autoMatch,
                    recruiterScreening: this.job.recruiterScreening,
                    techAssessmentId: this.job.techAssessmentId,
                    techAssessmentScore: this.job.techAssessmentScore,
                    techAssessment: this.job.techAssessment,
                    valueAssessmentId: this.job.valueAssessmentId,
                    valueAssessment: this.job.valueAssessment,
                    eduVerification: this.job.eduVerification,
                    expVeification: this.job.expVeification,
                    phoneScreen: this.job.phoneScreen,
                    interview: this.job.interview,
                    imageProctoring: this.job.imageProctoring,
                    addProctoringImagesToReport: this.job.addProctoringImagesToReport,
                    workflowStepsOrder: angular.copy(this.job.workflowStepsOrder),
                    includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
                    includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
                    // jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    // resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    tab: "WORKFLOW_STEPS"
                };
                stepDataHasChangedFlag = !(angular.equals(this.workflowStepsTempObject, currentWorkflowStepsObject)) || !this.isLicensePreferenceSet;
                ;
                break;
            case 4:
                var currentJobBoardsSettingsObject = {
                    // jobId: this.job.id,
                    // autoMatch: this.job.autoMatch,
                    jobBoardDetails: angular.copy(this.job.jobBoardDetails),
                    resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
                    isResumePullEnabled: this.job.isResumePullEnabled,
                    radius: this.job.radius,
                    recency: this.job.recency,
                    tab: "JOB_BOARDS"
                };
                stepDataHasChangedFlag = !(angular.equals(this.jobBoardsSettingsTempObject, currentJobBoardsSettingsObject)) || (this.job.isResumePullEnabled);
                if (!this.isJobBoardDetailsSet)
                    stepDataHasChangedFlag = true;
                break;
            case 5:
                //do nothing
                break;
            case 6:
                var adjustedScore = $('.slider-adjust-4dot5-score').val();
                if (this.isInitialStateDraft || adjustedScore != this.job.score) {
                    stepDataHasChangedFlag = true;
                }
                break;
            default:
                break;
        }
        return stepDataHasChangedFlag;
    };
    UploadReqPageController.prototype._enableStepActionsOnWizard = function (currentStep) {
        switch (currentStep) {
            case 1:
                this.step1RequestWasInProgressFlag = false;
                break;
            case 2:
                this.step2RequestWasInProgressFlag = false;
                break;
            case 3:
                this.step3RequestWasInProgressFlag = false;
                break;
            case 4:
                this.step4RequestWasInProgressFlag = false;
                break;
            case 5:
                this.step5RequestWasInProgressFlag = false;
                break;
            case 6:
                this.step5RequestWasInProgressFlag = false;
                break;
            default:
                break;
        }
        this.disableAllButtonsFlag = false;
    };
    UploadReqPageController.prototype.wizardSaveStepData = function (clickedButton) {
        var _this = this;
        var currentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        this._parseWorkflowStepsOrderBeforeSave();
        if (this.currentJobStatus !== 'DRAFT') {
            //step 6 is the last step
            if (currentStep == 5) {
                currentStep = 6;
            }
        }
        if (this._isStepDataValid(currentStep)) {
            if (this._hasStepDataChanged(currentStep) || (this.currentJobStatus == 'DRAFT' && currentStep == 5 && this.isActivateRequisitionEnabled) || (currentStep == 6 && this.isWorkFlowStep4Dot5ScoreChanged)) {
                switch (currentStep) {
                    case 1:
                        if (this.currentJobStatus == 'DRAFT' && !this.job.id) {
                            this.createRequisitionWithouFile(function () {
                                if (!_this.editModeFlag) {
                                    _this.getRecruiters(function () {
                                        _this._setRecruitersAndHiringManagers();
                                    });
                                    if (!_this.isCorporate) {
                                        _this.getPointOfContacts(function () {
                                            _this._setPocs();
                                        });
                                    }
                                    if (!_this.clientOrBUIsRequiredFlag) {
                                        _this.getBuVendors(function () {
                                            _this._setBuVendors();
                                        });
                                    }
                                }
                            }, function () { });
                        }
                        else {
                            if (this.currentJobStatus == 'DRAFT') {
                                this._saveStep1(false, function () { }, function () { });
                            }
                            else {
                                this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, function () {
                                    _this._saveStep1(true, function () {
                                        // this.reRunResumeScore(null, () => {});
                                        _this.isRecalcucateScoreNoClicked = false;
                                    }, function () { });
                                }, function () {
                                    _this._saveStep1(false, function () {
                                        _this.isRecalcucateScoreNoClicked = true;
                                    }, function () { });
                                });
                            }
                        }
                        break;
                    case 2:
                        if (this._hasRecruitersBeingUnAssigned() || this._hasVendorsBeingUnAssigned()) {
                            if (this._hasRecruitersBeingUnAssigned() && this._hasVendorsBeingUnAssigned()) {
                                // show both warnings
                                var warningMessage = this._getAssignedRecruitersWarningMessage();
                                warningMessage = warningMessage + "<br><br>" + this._getVendorsRemovedWarningMessage();
                                this._showWarningMessage(warningMessage, function () {
                                    _this._saveStep2('SAVE');
                                }, function () {
                                    _this.job.vendorIds = angular.copy(_this.step2DetailsTempObject.vendorIds);
                                    _this._setBuVendors();
                                    _this.job.recruiters = angular.copy(_this.step2DetailsTempObject.recruiters);
                                    _this._setRecruitersAndHiringManagers();
                                });
                            }
                            else if (this._hasVendorsBeingUnAssigned()) {
                                this._showVendorsRemovedWarning(function () {
                                    _this._saveStep2('SAVE');
                                }, function () {
                                    _this.job.vendorIds = angular.copy(_this.step2DetailsTempObject.vendorIds);
                                    _this._setBuVendors();
                                });
                            }
                            else {
                                this._showRecruitersUnAssignedWarning(function () {
                                    _this._saveStep2('SAVE');
                                }, function () {
                                    _this.job.recruiters = angular.copy(_this.step2DetailsTempObject.recruiters);
                                    _this._setRecruitersAndHiringManagers();
                                });
                            }
                        }
                        else {
                            this.disableAllButtonsFlag = true;
                            this.savingFlag = true;
                            this.utilityService.showLoadingModal("Saving...");
                            this.saveStep2Details('SAVE', function () {
                                _this.utilityService.hideLoadingModal();
                                _this.disableAllButtonsFlag = false;
                                _this.savingFlag = false;
                                if (_this.$rootScope.isOnline) {
                                    var successMessage = 'The Requisition details have been saved in Draft Status.';
                                    if (_this.currentJobStatus == 'OPEN') {
                                        successMessage = 'The Requisition details have been saved.';
                                    }
                                    _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                }
                                _this._createStepTempObject(currentStep);
                            }, function (error) {
                                _this.utilityService.hideLoadingModal();
                                _this.disableAllButtonsFlag = false;
                                _this.savingFlag = false;
                                if (_this.$rootScope.isOnline) {
                                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                }
                            });
                        }
                        break;
                    case 3:
                        if (this.currentJobStatus == 'DRAFT') {
                            this._updateDataAfterWorkflowStepsSaved(false, currentStep, function () { }, function () { });
                        }
                        else {
                            if (this.hasMatchingMandatoryCriteriaChanged() || this.hasMissingPreferenceDetailsChanged()) {
                                this.alertsAndNotificationsService.showConfirm("Recalculate Score", "Re-calculate the scores now?", "warning", true, function () {
                                    _this._updateDataAfterWorkflowStepsSaved(true, currentStep, function () {
                                        // this.reRunResumeScore(null, () => { });
                                    }, function () { });
                                }, function () {
                                    _this._updateDataAfterWorkflowStepsSaved(false, currentStep, function () {
                                        _this.isRecalcucateScoreNoClicked = true;
                                    }, function () { });
                                });
                            }
                            else {
                                this._updateDataAfterWorkflowStepsSaved(false, currentStep, function () { }, function () { });
                            }
                        }
                        break;
                    case 4:
                        this.disableAllButtonsFlag = true;
                        this.savingFlag = true;
                        this.saveJobBoardsSettings('SAVE', function () {
                            _this.disableAllButtonsFlag = false;
                            _this.savingFlag = false;
                            var successMessage = "";
                            // show the message that the job is saved state
                            if (_this.$rootScope.isOnline) {
                                if (_this.currentJobStatus == 'OPEN') {
                                    successMessage = "All the parameters have been saved. ";
                                    if (_this.job.isResumePullEnabled) {
                                        successMessage = successMessage + "Only when you click ‘Next’ will more resumes be pulled ";
                                        if (_this.job.autoMatch) {
                                            successMessage = successMessage + "and matched from job boards.";
                                        }
                                    }
                                    else {
                                        if (_this.job.autoMatch) {
                                            successMessage = successMessage + "Only when you click ‘Next’ candidates will be matched.";
                                        }
                                    }
                                }
                                if (_this.currentJobStatus == 'DRAFT') {
                                    successMessage = "All the parameters have been saved. Requisition is in Draft Status. Only when you hit 'Next' will the status be changed to 'Open'. ";
                                    if (_this.job.autoMatch) {
                                        successMessage = successMessage + "Matching of candidates to requisition will also happen only when you hit 'Next'.";
                                    }
                                }
                                _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            }
                            // this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
                            _this._createStepTempObject(currentStep);
                        }, function (error) {
                            _this.disableAllButtonsFlag = false;
                            _this.savingFlag = false;
                            if (_this.$rootScope.isOnline) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                        });
                        break;
                    case 5:
                        this.step5RequestWasInProgressFlag = true;
                        this._setJobStateToOpenAndRunForScoring(function () {
                            var message = "Requisition activation process has started in the background and will inform all users on the Requisition when its completed.";
                            _this.alertsAndNotificationsService.showAlertWithCallBack("Requisition Activation", message, "success", function () {
                                _this.$state.go('missioncontrol.requisitions');
                            });
                        }, function () { });
                        break;
                    case 6:
                        this.disableAllButtonsFlag = true;
                        this.savingFlag = true;
                        var adjustedScore = $('.slider-adjust-4dot5-score').val();
                        this.saveAdjusted4dot5Score(adjustedScore, function (data) {
                            _this.isWorkFlowStep4Dot5ScoreChanged = false;
                            _this.disableAllButtonsFlag = false;
                            _this.savingFlag = false;
                            // show the message that the score is updated
                            if (_this.$rootScope.isOnline) {
                                var successMessage = 'The Job Match Score has been updated.';
                                _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                            }
                        }, function (error) {
                            _this.disableAllButtonsFlag = false;
                            _this.savingFlag = false;
                            if (_this.$rootScope.isOnline) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                        });
                        break;
                    default:
                        break;
                }
            }
            else {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage('Nothing to be saved!', 'info');
                }
            }
        }
    };
    UploadReqPageController.prototype.isPrimaryHiringManagerSelected = function () {
        var managers = _.filter(this.job.hiringManagers, function (manager) {
            return manager.isPrimary == true;
        });
        if (managers.length > 0) {
            return true;
        }
        return false;
    };
    UploadReqPageController.prototype.validateStepOne = function () {
        var _this = this;
        this.$timeout(function () {
            if (_this.forms.step1Form && _this.forms.step1Form.$submitted) {
                if (!_this.req.clientOrBU || !_this.sharedClientBuOrCorp) {
                    _this.step1Error.hasErrorFlag = true;
                    _this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                }
                else {
                    _this.step1Error.hasErrorFlag = false;
                    _this.step1Error.errorMessage = '';
                }
            }
        }, 100);
    };
    UploadReqPageController.prototype.validateStepTwo = function () {
        var _this = this;
        this.$timeout(function () {
            if (_this.forms.step2Form && _this.forms.step2Form.$submitted) {
                if (_this.forms.step2Form.$invalid || (_this.job.jobType == null) || (_this.job.recruiters.length == 0) || (_this.job.sponsorshipProvided && _this.job.sponsorships.length == 0) || (_this.job.hiringManagers.length > 0 && !_this.isPrimaryHiringManagerSelected()) || (_this.job.vendorIds.length > 0 && _.isNull(_this.job.pointOfContactUserId))) {
                    _this.step2Error.hasErrorFlag = true;
                    _this.step2Error.errorMessage = 'Please enter all mandatory fields.';
                }
                else {
                    _this.step2Error.hasErrorFlag = false;
                    _this.step2Error.errorMessage = '';
                }
            }
        }, 100);
    };
    UploadReqPageController.prototype.validateStepThree = function () {
        var _this = this;
        this.$timeout(function () {
            if (_this.forms.step3Form.$submitted && _this.forms.step3Form.$invalid) {
                _this.step3Error.hasErrorFlag = true;
                _this.step3Error.errorMessage = 'Please enter all mandatory fields.';
            }
            else {
                _this.step3Error.hasErrorFlag = false;
                _this.step3Error.errorMessage = '';
            }
        }, 100);
    };
    UploadReqPageController.prototype.wizardCancel = function () {
        var _this = this;
        var currentStep = $("#uploadReqWizard").wizard('selectedItem');
        if (this._hasStepDataChanged(currentStep.step)) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        _this.resetStepData(currentStep.step, function () {
                            _this.$state.go('missioncontrol.requisitions');
                        });
                        if (_this.isRecalcucateScoreNoClicked) {
                            _this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', function () { });
                        }
                    }
                }
            });
        }
        else {
            if (this.isRecalcucateScoreNoClicked) {
                this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', function () {
                    _this.$state.go('missioncontrol.requisitions');
                });
            }
            else {
                this.$state.go('missioncontrol.requisitions');
            }
        }
    };
    UploadReqPageController.prototype.resetStepData = function (step, successCallback) {
        var _this = this;
        this.$timeout(function () {
            switch (step) {
                case 1:
                    _this.isStepOneActive = false;
                    _this.job.id = _this.step1DetailsTempObject.jobId;
                    _this.job.title = _this.step1DetailsTempObject.title;
                    if (_this.currentJobStatus !== 'DRAFT') {
                        _this.job.isSharedClientRequisition = _this.step1DetailsTempObject.isSharedClientRequisition;
                        _this.job.sharedClientBuOrCorpId = _this.step1DetailsTempObject.sharedClientBuOrCorpId;
                    }
                    else {
                        _this.req.isSharedClientRequisition = _this.step1DetailsTempObject.isSharedClientRequisition;
                        _this.req.sharedClientBuOrCorpId = _this.step1DetailsTempObject.sharedClientBuOrCorpId;
                    }
                    _this.job.requisitionNumber = _this.step1DetailsTempObject.requisitionNumber;
                    _this.isFutureMatchesOnly = _this.step1DetailsTempObject.isFutureMatchesOnly;
                    _this.job.profileCriteriaInfo = _this.step1DetailsTempObject.profileCriteriaInfo;
                    _this.job.includeCandidatesWithNoAdditionalDetails = _this.step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails;
                    _this.job.includeCandidatesMatchingMandatoryCriteria = _this.step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria;
                    //do nothing
                    break;
                case 2:
                    _this.isStepOneActive = false;
                    _this.job.title = _this.step2DetailsTempObject.title;
                    _this.job.isSharedClientRequisition = _this.step2DetailsTempObject.isSharedClientRequisition;
                    _this.job.sharedClientBuOrCorpId = _this.step2DetailsTempObject.sharedClientBuOrCorpId;
                    if (_.isNull(_this.step2DetailsTempObject.clientOrBUId)) {
                        _this.job.clientorbu = null;
                    }
                    else {
                        angular.forEach(_this.clientorbulist, function (val, key) {
                            if (val.id == _this.step2DetailsTempObject.clientOrBUId) {
                                _this.job.clientorbu = val;
                            }
                        });
                    }
                    _this.job.requisitionNumber = _this.step2DetailsTempObject.requistionNumber;
                    _this.job.openings = _this.step2DetailsTempObject.openings;
                    _this.job.jobType = _this.step2DetailsTempObject.jobType;
                    _this.job.contractDuration = _this.step2DetailsTempObject.contractDuration;
                    _this.job.requisitionNote = _this.step2DetailsTempObject.requisitionNote;
                    _this.job.jobSalary = angular.copy(_this.step2DetailsTempObject.jobSalary);
                    _this._setJobType();
                    _this.job.sponsorships = _this.step2DetailsTempObject.sponsorships;
                    _this.job.sponsorshipProvided = _this.step2DetailsTempObject.sponsorshipProvided;
                    _this._setSponsorshipType();
                    _this.job.workLocationIds = _this.step2DetailsTempObject.workLocationIds;
                    _this._setWorkLocations();
                    _this.job.recruiters = _this.step2DetailsTempObject.recruiters;
                    _this.job.hiringManagers = angular.copy(_this.step2DetailsTempObject.hiringManagers);
                    _this.job.vendorIds = _this.step2DetailsTempObject.vendorIds;
                    _this.job.salary = _this.step2DetailsTempObject.salary;
                    _this._setRecruitersAndHiringManagers();
                    _this._setBuVendors();
                    break;
                case 3:
                    _this.job.score = _this.workflowStepsTempObject.score;
                    $('.slider-intelligence').val(_this.job.score);
                    $('#4dot5IntelligenceScoreDisplayValue').text(_this.job.score);
                    _this.job.autoMatch = _this.workflowStepsTempObject.autoMatch;
                    _this.job.recruiterScreening = _this.workflowStepsTempObject.recruiterScreening;
                    _this.job.techAssessmentId = _this.workflowStepsTempObject.techAssessmentId;
                    _this.job.techAssessment = _this.workflowStepsTempObject.techAssessment;
                    _this.job.techAssessmentScore = _this.workflowStepsTempObject.techAssessmentScore;
                    $('.slider-tech-assessment').val(_this.job.techAssessmentScore);
                    $('#techAssessmentScoreDisplayValue').text(_this.job.techAssessmentScore);
                    _this.job.valueAssessment = _this.workflowStepsTempObject.valueAssessment;
                    _this.job.techAssessmentScore = _this.workflowStepsTempObject.techAssessmentScore;
                    _this.job.valueAssessmentId = _this.workflowStepsTempObject.valueAssessmentId;
                    _this.job.eduVerification = _this.workflowStepsTempObject.eduVerification;
                    _this.job.expVeification = _this.workflowStepsTempObject.expVeification;
                    _this.job.phoneScreen = _this.workflowStepsTempObject.phoneScreen;
                    _this.job.interview = _this.workflowStepsTempObject.interview;
                    _this.job.imageProctoring = _this.workflowStepsTempObject.imageProctoring;
                    _this.job.addProctoringImagesToReport = _this.workflowStepsTempObject.addProctoringImagesToReport;
                    _this.job.workflowStepsOrder = angular.copy(_this.workflowStepsTempObject.workflowStepsOrder);
                    // this.job.jobBoardDetails = angular.copy(this.workflowStepsTempObject.jobBoardDetails);
                    // this.job.resumesToPullPerJobBoardCount = this.workflowStepsTempObject.resumesToPullPerJobBoardCount;
                    _this.job.includeCandidatesWithNoAdditionalDetails = _this.workflowStepsTempObject.includeCandidatesWithNoAdditionalDetails;
                    _this.job.includeCandidatesMatchingMandatoryCriteria = _this.workflowStepsTempObject.includeCandidatesMatchingMandatoryCriteria;
                    break;
                case 4:
                    _this.job.jobBoardDetails = angular.copy(_this.jobBoardDetailsCopy);
                    _this.job.resumesToPullPerJobBoardCount = _this.jobBoardsSettingsTempObject.resumesToPullPerJobBoardCount;
                    _this.job.isResumePullEnabled = _this.jobBoardsSettingsTempObject.isResumePullEnabled;
                    _this.job.radius = _this.jobBoardsSettingsTempObject.radius;
                    _this.job.recency = _this.jobBoardsSettingsTempObject.recency;
                    break;
                case 5:
                    //do nothing
                    break;
                case 6:
                    $('.slider-adjust-4dot5-score').val(_this.job.score);
                    $('#adjust4dot5ScoreDisplayValue').text(_this.job.score);
                    _this.getCandidateCount(_this.job.score, 'adjustedScore');
                    break;
                default:
                    break;
            }
            if (successCallback) {
                successCallback();
            }
        }, 100);
    };
    UploadReqPageController.prototype.getJobScoringJobStatus = function () {
        var _this = this;
        this.jobService.getJobScoringJobStatus(this.job.id, function (data) {
            _this.scoringInProgress = data;
            if (_this.scoringInProgress) {
                var message = "Job matching process is in progress and will inform all users on the Requisition when its completed.";
                _this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message, "success", function () {
                    _this.$state.go('missioncontrol.requisitions');
                });
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    /**
     * this function fetches all client or bu list from service
     */
    UploadReqPageController.prototype.getAllClientsOrBu = function (successCallback) {
        var _this = this;
        var requisitionId = _.isNull(this.job.id) ? null : this.job.id;
        var isFromCreateReq = false;
        if (!requisitionId) {
            isFromCreateReq = true;
        }
        this.requisitionService.getAllClientsOrBu(this.userDetails, requisitionId, isFromCreateReq, function (data) {
            _this.clientorbulist = data;
            angular.forEach(_this.clientorbulist, function (clientOrBu, key) {
                if (clientOrBu.companyType == 'Corporation') {
                    clientOrBu.displayName = clientOrBu.name + " &#xf1e0;";
                }
                else {
                    clientOrBu.displayName = clientOrBu.name;
                }
            });
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype._setClientOrBu = function (clientorbu) {
        if (!_.isNull(clientorbu)) {
            this.req.clientOrBU = {
                name: clientorbu.name,
                companyType: clientorbu.companyType,
                companyState: clientorbu.companyState,
                id: clientorbu.id,
                shortName: clientorbu.shortName
            };
        }
        else {
            this.req.clientOrBU = null;
        }
    };
    UploadReqPageController.prototype.getAllJobTypes = function (successCallback) {
        var _this = this;
        this.jobService.getAllJobTypes(function (data) {
            _this.jobTypeList = data;
            _this.job.jobTypeLabel = (_this.job.jobType && _this.jobTypeList.length > 0) ? _this.jobTypeList.filter(function (jobType) { return jobType.value == _this.job.jobType; })[0].name : null;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype.getAllWorkLocations = function (successCallback) {
        var _this = this;
        this.jobService.getWorkLocations(function (data) {
            _this.workLocationsList = data.filter(function (location) { return location.name !== "No Work Location"; });
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype.onClientOrBuChanged = function () {
        var _this = this;
        var clientOrBusWithoutNoAssociatedBus = this.clientorbulist.filter(function (clientOrBu) { return clientOrBu.id !== ""; });
        var selectedClientOrBu = _.find(clientOrBusWithoutNoAssociatedBus, { id: this.job.clientorbu.id });
        this.job.clientorbu = angular.copy(selectedClientOrBu);
        this.req.clientOrBU = angular.copy(selectedClientOrBu);
        this.editBUFlag = !this.editBUFlag;
        this.job.recruiters = [];
        this.job.hiringManagers = [];
        this.job.vendorIds = [];
        this.job.pointOfContactUserId = null;
        // get recruiters
        this.getRecruiters(function () {
            _this._setRecruitersAndHiringManagers();
        });
        //get bu vendors
        if (!this.clientOrBUIsRequiredFlag) {
            this.getBuVendors(function () {
                _this._setBuVendors();
            });
        }
        //get shared client bus
        if (this.job.clientorbu && this.job.clientorbu.companyType == 'Corporation') {
            this.req.isSharedClientRequisition = true;
            this.job.isSharedClientRequisition = true;
            this._getSharedClientBus();
        }
        else {
            this.req.isSharedClientRequisition = false;
            this.job.isSharedClientRequisition = false;
            this.req.sharedClientBuOrCorpId = null;
            this.job.sharedClientBuOrCorpId = null;
            this.sharedCorporateId = null;
            this.sharedClientBuOrCorp = {};
        }
        this.getAllJobBoards(function () {
            _this._setJobBoardDetails();
        });
    };
    UploadReqPageController.prototype.onJobTypeSelected = function (multiSelectAction) {
        var _this = this;
        if (this.selectedJobTypes.length > 0) {
            if (!this.candidatesPresentOnJob) {
                this.job.jobType = this.selectedJobTypes[0].value;
                if (this.job.jobType !== "CONTRACTOR" && this.job.jobType !== "CONTRACTTOHIRE") {
                    this.job.contractDuration = null;
                }
                this.hasJobTypeChanged = true;
                this.isJobTypeChanged = true;
                this._massageWorkflowStepsOrder();
            }
            else if (multiSelectAction == 'close') {
                this._showcandidatesPresentOnJobWarningMessage(function () {
                    _this._setJobType();
                });
            }
        }
        else {
            this.job.jobType = null;
        }
        this.validateStepTwo();
    };
    UploadReqPageController.prototype.onPocSelected = function () {
        if (this.selectedPocs.length > 0) {
            this.job.pointOfContactUserId = this.selectedPocs[0].userId;
        }
        else {
            this.job.pointOfContactUserId = null;
        }
        this.validateStepTwo();
    };
    UploadReqPageController.prototype._setJobType = function () {
        var _this = this;
        if (angular.isDefined(this.job.jobType)) {
            for (var k = 0; k < this.jobTypeList.length; k++) {
                if (this.job.jobType === this.jobTypeList[k].value) {
                    this.jobTypeList[k].selected = true;
                }
                else {
                    this.jobTypeList[k].selected = false;
                }
            }
        }
        else {
            for (var i = 0; i < this.jobTypeList.length; i++) {
                this.jobTypeList[i].selected = false;
            }
        }
        var selectedJobTypeArray = _.filter(this.jobTypeList, function (jobType) {
            return jobType.value == _this.job.jobType;
        });
        if (selectedJobTypeArray.length > 0) {
            this.selectedJobType = selectedJobTypeArray[0].name;
        }
        else {
            this.selectedJobType = null;
        }
        this._setSalaryLabel();
    };
    UploadReqPageController.prototype._setSalaryLabel = function () {
        if (this.selectedJobType == 'Contractor' || this.selectedJobType == 'Contract to Hire') {
            this.salaryLabel = this.isCorporate ? "Bill Rate" : "Client/Bill Rate";
        }
        else {
            this.salaryLabel = 'Salary';
        }
        this._setSalaryRangeOptions();
    };
    UploadReqPageController.prototype._setSalaryRangeOptions = function () {
        if (this.selectedJobType) {
            if (this.selectedJobType !== 'Full Time') {
                // Bill Rate: exclude PER_YEAR, default to PER_HOUR (By Hour)
                this.salaryDurationOptions = this.allSalaryDurationOptions.filter(function (salaryDuration) { return salaryDuration.value != 'PER_YEAR'; });
                if (!this.isJobTypeChanged) {
                    // If existing saved duration is PER_YEAR (legacy data), show all options to avoid blank dropdown
                    if (this.job.jobSalary && this.job.jobSalary.salaryDuration === 'PER_YEAR') {
                        this.salaryDurationOptions = tslib_1.__spread(this.allSalaryDurationOptions);
                    }
                }
                else {
                    // User actively changed job type — always default to PER_HOUR
                    if (!this.job.jobSalary) {
                        this.job.jobSalary = new JobSalary();
                        this.job.jobSalary.currency = 'USD';
                    }
                    this.job.jobSalary.salaryDuration = 'PER_HOUR';
                }
            }
            else {
                // Salary (Full Time and all other job types): only PER_YEAR, default to PER_YEAR (By Year)
                this.salaryDurationOptions = this.allSalaryDurationOptions.filter(function (salaryDuration) { return salaryDuration.value === 'PER_YEAR'; });
                if (this.job.jobSalary) {
                    this.job.jobSalary.salaryDuration = 'PER_YEAR';
                }
            }
        }
        else {
            this.salaryDurationOptions = tslib_1.__spread(this.allSalaryDurationOptions);
        }
    };
    UploadReqPageController.prototype.getAllSponsorshipTypes = function (successCallback) {
        var _this = this;
        this.jobService.getAllSponsorshipTypes(function (data) {
            _this.sponsorshipList = data.filter(function (sponsorship) { return sponsorship.value != 'NO_WORK_AUTHORIZATION_SPECIFIED'; });
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype._setSponsorshipType = function () {
        var _this = this;
        if (this.sponsorshipList) {
            if (this.job.sponsorships) {
                this.selectedSponsorships = angular.copy(this.job.sponsorships);
                angular.forEach(this.sponsorshipList, function (val, key) {
                    if (_this.job.sponsorships.indexOf(val.value) > -1) {
                        val.selected = true;
                    }
                    else {
                        val.selected = false;
                    }
                });
            }
        }
    };
    UploadReqPageController.prototype.onSponsorshipProvidedSelected = function () {
        if (!this.job.sponsorshipProvided) {
            this._setSponsorshipSelectedDefault(true);
            this.validateStepTwo();
        }
    };
    UploadReqPageController.prototype._setSponsorshipSelectedDefault = function (sponsorshipChanged) {
        var _this = this;
        if ((this.sponsorshipList && _.isNull(this.job.sponsorships)) || sponsorshipChanged) {
            this.selectedSponsorships = ['CITIZENONLY', 'PERMANENTRESIDENTORGREENCARD'];
            angular.forEach(this.sponsorshipList, function (val, key) {
                val.selected = _this.selectedSponsorships.indexOf(val.value) > -1 ? true : false;
            });
            this.job.sponsorships = angular.copy(this.selectedSponsorships);
        }
    };
    UploadReqPageController.prototype.onWorkLocationsSelected = function () {
        var _this = this;
        this.job.workLocationIds = [];
        if (this.selectedWorkLocationsList.length > 0) {
            this.selectedWorkLocationsList.forEach(function (workLocation) {
                _this.job.workLocationIds.push(workLocation.id);
            });
        }
    };
    UploadReqPageController.prototype._setWorkLocations = function () {
        var _this = this;
        if (this.job.workLocationIds) {
            this.workLocationsList.forEach(function (workLocation) {
                workLocation.selected = _this.job.workLocationIds.indexOf(workLocation.id) > -1;
            });
        }
    };
    UploadReqPageController.prototype.onSponsorshipSelected = function (index, sponsorship) {
        this.job.sponsorships = [];
        if (sponsorship.selected === true) {
            this.selectedSponsorships.push(sponsorship.value);
        }
        else {
            this.selectedSponsorships = this.selectedSponsorships.filter(function (item) { return item != sponsorship.value; });
        }
        this.job.sponsorships = angular.copy(this.selectedSponsorships);
        this.validateStepTwo();
    };
    UploadReqPageController.prototype.onAssessmentChange = function (assessmentType) {
        if (assessmentType == 'Technical' && this.job.techAssessmentId !== this.workflowStepsTempObject.techAssessmentId && this.sentTechnicalAssessmentsDetail.count > 0) {
            this._showCancelAssessmentsConfirmation(assessmentType);
        }
        else if (assessmentType == 'Value' && this.job.valueAssessmentId !== this.workflowStepsTempObject.valueAssessmentId && this.sentValueAssessmentsDetail.count > 0) {
            this._showCancelAssessmentsConfirmation(assessmentType);
        }
    };
    UploadReqPageController.prototype._showCancelAssessmentsConfirmation = function (assessmentType) {
        var _this = this;
        var message = "";
        var assessmentsCount = assessmentType == 'Technical' ? this.sentTechnicalAssessmentsDetail.count : this.sentValueAssessmentsDetail.count;
        message = "There are " + assessmentsCount + " " + assessmentType + " assessments that have already been sent out using the previous assessment. Do you want to cancel it? Cancellation notices will be sent out. This action cannot be undone!";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cancel Sent Assessments!</strong></div>",
            message: message,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this.cancelSentAssessments(assessmentType);
                }
                else {
                    _this._resetAssessmentId(assessmentType);
                }
            }
        });
    };
    UploadReqPageController.prototype._resetAssessmentId = function (assessmentType) {
        if (assessmentType == 'Technical') {
            this.job.techAssessmentId = this.workflowStepsTempObject.techAssessmentId;
        }
        else {
            this.job.valueAssessmentId = this.workflowStepsTempObject.valueAssessmentId;
        }
    };
    UploadReqPageController.prototype.cancelSentAssessments = function (assessmentType) {
        var _this = this;
        var candidateAssessmentIds = [];
        if (assessmentType == "Technical") {
            candidateAssessmentIds = this.sentTechnicalAssessmentsDetail.candidateAssessmentIds;
        }
        else {
            candidateAssessmentIds = this.sentValueAssessmentsDetail.candidateAssessmentIds;
        }
        this.candidateService.cancelSentAssessments(candidateAssessmentIds, this.companyId, function (data) {
            _this.alertsAndNotificationsService.showBannerMessage('All the assessments that were sent to candidates have been cancelled successfully', 'success');
            _this.sentTechnicalAssessmentsDetail = new SentAssessmentDetail();
            _this.sentValueAssessmentDetail = new SentAssessmentDetail();
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.getAllTechAssessments = function (successCallback) {
        var _this = this;
        var clientOrBuId = null;
        var isJobWorkflow = true;
        if (this.job.clientorbu) {
            clientOrBuId = this.job.clientorbu.id;
        }
        this.assessmentService.getAllTechAssessments(this.companyId, clientOrBuId, isJobWorkflow, function (data) {
            _this.techAssessmentList = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (successCallback) {
                successCallback();
            }
        });
    };
    UploadReqPageController.prototype.getAllValueAssessments = function (successCallback) {
        var _this = this;
        var clientOrBuId = null;
        var isJobWorkflow = true;
        if (this.job.clientorbu) {
            clientOrBuId = this.job.clientorbu.id;
        }
        this.assessmentService.getAllValueAssessments(this.companyId, clientOrBuId, isJobWorkflow, function (data) {
            if (data.length > 0) {
                _this.valueAssessmentList = data;
            }
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (successCallback) {
                successCallback();
            }
        });
    };
    UploadReqPageController.prototype.getAllJobBoards = function (successCallback) {
        var _this = this;
        var buId = null;
        if (this.job.clientorbu && this.isCorporate) {
            buId = this.job.clientorbu.id;
        }
        this.resumeService.getResumeSourceTypes(this.companyId, buId, function (data) {
            if (data.length > 0) {
                _this.isJobBoardSelected = true;
                angular.forEach(data, function (val, key) {
                    val.boardId = val.id;
                    val.enabled = true;
                    delete val.id;
                });
                if (successCallback) {
                    successCallback();
                }
            }
            _this.jobBoardDetails = data;
            _this.job.jobBoardDetails = angular.copy(_this.jobBoardDetails);
            _this.jobBoardDetailsCopy = angular.copy(_this.job.jobBoardDetails);
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype._setJobBoardDetails = function () {
        var _this = this;
        this.job.jobBoardDetails = angular.copy(this.jobBoardDetails);
        if (!_.isNull(this.job.licensePreferences) && !_.isNull(this.job.licensePreferences.jobBoardDetails)) {
            angular.forEach(this.job.jobBoardDetails, function (val, key) {
                if (_.findIndex(_this.job.licensePreferences.jobBoardDetails, { 'boardId': val.boardId, 'enabled': true }) == -1) {
                    val.enabled = false;
                }
            });
        }
        angular.forEach(this.job.jobBoardDetails, function (val, key) {
            if (val.enabled == true) {
                _this.isJobBoardSelected = true;
                console.log(_this.isJobBoardSelected);
            }
        });
        this.jobBoardDetailsCopy = angular.copy(this.job.jobBoardDetails);
    };
    UploadReqPageController.prototype.getRecruiters = function (successCallback) {
        var _this = this;
        var clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        var requisitionId = _.isNull(this.job.id) ? null : this.job.id;
        var clientOrBuIds = [];
        var requisitionNumbers = [];
        var isUploadOrEditReq = true;
        this.jobService.getAllRecruiters(this.userDetails, this.userDetails.company, clientOrBUId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, function (data) {
            _this.recruiterList = data.recruiters;
            _this.hiringManagerList = data.hiringManagers;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype.getPointOfContacts = function (successCallback) {
        var _this = this;
        var clientOrBUId = this.job.isSharedClientRequisition ? this.job.sharedClientBuOrCorpId : this.job.clientorbu.id;
        var corporateId = this.sharedCorporateId;
        if (corporateId == clientOrBUId) {
            clientOrBUId = null;
        }
        this.companyService.getClientOrBuPocs(corporateId, clientOrBUId, function (data) {
            _this.pocs = data;
            angular.forEach(_this.pocs, function (poc) {
                poc.userId = poc.id;
            });
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype.getBuVendors = function (successCallback) {
        var _this = this;
        var buId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        this.jobService.getBuVendors(this.userDetails.company.companyId, buId, function (data) {
            _this.vendorsList = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadReqPageController.prototype.onRecruitersSelected = function () {
        var _this = this;
        this.job.recruiters = [];
        if (this.selectedRecruiters.length > 0) {
            angular.forEach(this.selectedRecruiters, function (recruiter, key) {
                _this.job.recruiters.push(recruiter.userId);
            });
        }
        this.validateStepTwo();
        if (this.isCorporate) {
            this._setPoc();
        }
    };
    UploadReqPageController.prototype.onHiringManagersSelected = function () {
        var _this = this;
        this.job.hiringManagers = [];
        if (this.selectedHiringManagers.length !== 0 && this.selectedHiringManagers.length > 1) {
            angular.forEach(this.selectedHiringManagers, function (hiringManager, key) {
                hiringManager.isPrimary = hiringManager.userId === _this.primaryHiringManagerId ? true : false;
                _this.job.hiringManagers.push({ id: hiringManager.userId, isPrimary: hiringManager.isPrimary });
            });
            this.primaryHiringManagerList = angular.copy(this.selectedHiringManagers);
        }
        else if (this.selectedHiringManagers.length == 1) {
            this.primaryHiringManagerId = this.selectedHiringManagers[0].userId;
            this.selectedHiringManagers[0].isPrimary = true;
            this.job.hiringManagers.push({ id: this.selectedHiringManagers[0].userId, isPrimary: this.selectedHiringManagers[0].isPrimary });
            this.primaryHiringManagerList = angular.copy(this.selectedHiringManagers);
        }
        if (this.isCorporate) {
            this._setPoc();
        }
    };
    UploadReqPageController.prototype.onPrimaryHiringManagerSelected = function (selectedHiringManager) {
        var _this = this;
        angular.forEach(this.job.hiringManagers, function (manager, key) {
            if (manager.id == selectedHiringManager.userId) {
                manager.isPrimary = true;
                _this.primaryHiringManagerId = manager.id;
            }
            else {
                manager.isPrimary = false;
            }
        });
        angular.forEach(this.primaryHiringManagerList, function (manager, key) {
            if (manager.userId == selectedHiringManager.userId) {
                manager.isPrimary = true;
            }
            else {
                manager.isPrimary = false;
            }
        });
        this.validateStepTwo();
        if (this.isCorporate) {
            this._setPoc();
        }
    };
    UploadReqPageController.prototype.onVendorsSelected = function () {
        var _this = this;
        this.job.vendorIds = [];
        if (this.selectedVendors.length > 0) {
            angular.forEach(this.selectedVendors, function (vendor, key) {
                _this.job.vendorIds.push(vendor.vendorId);
            });
        }
        this.validateStepTwo();
    };
    UploadReqPageController.prototype._setRecruitersAndHiringManagers = function () {
        var _this = this;
        angular.forEach(this.recruiterList, function (val, key) {
            if (_this.job.recruiters.indexOf(val.userId) > -1) {
                val.selected = true;
            }
            else {
                val.selected = false;
            }
        });
        angular.forEach(this.hiringManagerList, function (val, key) {
            var managers = _.filter(_this.job.hiringManagers, function (manager) {
                return manager.id == val.userId;
            });
            if (managers.length > 0) {
                val.selected = true;
                val.isPrimary = managers[0].isPrimary;
                if (val.isPrimary) {
                    _this.primaryHiringManagerId = val.userId;
                }
            }
            else {
                val.selected = false;
            }
        });
        this.primaryHiringManagerList = _.filter(this.hiringManagerList, function (manager) { return manager.selected == true; });
        if (this.isCorporate) {
            this._setPoc();
        }
    };
    UploadReqPageController.prototype._setPocs = function () {
        var _this = this;
        angular.forEach(this.pocs, function (poc, key) {
            if (_this.job.pointOfContactUserId == poc.userId) {
                poc.selected = true;
            }
            else {
                poc.selected = false;
            }
        });
    };
    UploadReqPageController.prototype._setPoc = function () {
        var _this = this;
        this.sharedJobPocs = [];
        //get all selected recruiters
        var pocs = _.filter(this.recruiterList, function (recruiter) {
            return recruiter.selected == true;
        });
        //get primary hiring manager
        angular.forEach(this.primaryHiringManagerList, function (hiringManager, key) {
            if (hiringManager.isPrimary) {
                pocs.push(hiringManager);
            }
        });
        this.sharedJobPocs = angular.copy(pocs);
        //check selected poc
        angular.forEach(this.sharedJobPocs, function (poc, key) {
            poc.selected = false;
            if (poc.userId == _this.job.pointOfContactUserId) {
                poc.selected = true;
            }
        });
    };
    UploadReqPageController.prototype._setBuVendors = function () {
        var _this = this;
        if (!this.job.vendorIds) {
            this.job.vendorIds = [];
        }
        angular.forEach(this.vendorsList, function (vendor, key) {
            if (_this.job.vendorIds.indexOf(vendor.vendorId) > -1) {
                vendor.selected = true;
            }
            else {
                vendor.selected = false;
            }
        });
    };
    UploadReqPageController.prototype.onTechAssessmentCheckboxClick = function () {
        if (this.job.techAssessment) {
            $('.slider-tech-assessment').removeAttr('disabled');
        }
        else {
            $('.slider-tech-assessment').attr('disabled', true);
        }
    };
    UploadReqPageController.prototype.onImageProctoringCheckboxClick = function () {
        if (!this.job.imageProctoring) {
            this.job.addProctoringImagesToReport = false;
        }
    };
    UploadReqPageController.prototype.getLicensePreferences = function (successCallback, errorCallback) {
        var _this = this;
        this.jobService.getLicensePreferences(this.userDetails.company, this.job.clientorbu, this.job.id, function (data) {
            _this.licensePreferenceDetails = data;
            if (_.isNull(_this.job.licensePreferences) || _.isNull(_this.job.licensePreferences.resumesToPullPerJobBoardCount)) {
                _this.job.resumesToPullPerJobBoardCount = _this.licensePreferenceDetails.resumesToPullPerJobBoardCount;
                _this.resumesToPullPerJobBoardCountCopy = _this.job.resumesToPullPerJobBoardCount;
                _this.job.isResumePullEnabled = false;
                _this.job.workflowStepsOrder = angular.copy(data.workflowStepsOrder);
            }
            if (_this.currentJobStatus != 'DRAFT') {
                // Refresh requisition icons
                _this.requisitionInfo.autoMatedMatchSelected = _this.licensePreferenceDetails.autoMatch.licensePrefDetailsList[0].enabled && _this.licensePreferenceDetails.autoMatch.licensePrefDetailsList[0].selected && (_this.job.licensePreferences && _this.job.licensePreferences.autoMatch);
            }
            successCallback();
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    UploadReqPageController.prototype._createWorkflowSliders = function (successCallback) {
        var _this = this;
        // empty the existing sliders
        $('.slider-intelligence').empty();
        $('.slider-tech-assessment').empty();
        $(document).ready(function () {
            angular.forEach(_this.licensePreferenceDetails, function (val, key) {
                switch (key) {
                    case 'fourDotFiveIntellList':
                        _this.intelligencePreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName
                        };
                        // if not in edit mode or if the score has not been set yet
                        if (!_this.editModeFlag || _.isNull(_this.job.score) || _this.hasClientOrBuChanged) {
                            _this.job.score = val.licensePrefDetailsList[0].licensePrefMarkerValue;
                        }
                        var sliderClass_1 = '.slider-intelligence';
                        $(sliderClass_1).noUiSlider({
                            range: [0, 100],
                            start: [_this.job.score],
                            handles: 1,
                            connect: 'lower',
                            step: 1,
                            slide: function () {
                                var val = $(sliderClass_1).val();
                                _this.job.score = val;
                                $('#4dot5IntelligenceScoreDisplayValue').text(val).addClass('slider-bold');
                                _this.isWorkFlowStep4Dot5ScoreChanged = true;
                            },
                            set: function () {
                                var val = $(sliderClass_1).val();
                                _this.job.score = val;
                                $('#4dot5IntelligenceScoreDisplayValue').text(val).removeClass('slider-bold');
                            }
                        });
                        // set the value onto the intelligence score value span which displays the current value
                        $('#4dot5IntelligenceScoreDisplayValue').text(_this.job.score);
                        break;
                    case 'techAssessmentList':
                        _this.techAssessmentPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (_this.editModeFlag) {
                            if (_this.techAssessmentPreferences.enabled) {
                                // in edit mode, if license preferences have already been defined and techAssessment value is true
                                if (!_.isNull(_this.job.licensePreferences) && _this.job.licensePreferences.techAssessment) {
                                    _this.job.techAssessment = true;
                                    // tech assessment score can be null for older assessments - then set the value to 0
                                    if (_.isNull(_this.job.techAssessmentScore)) {
                                        _this.job.techAssessmentScore = 0;
                                    }
                                }
                                else {
                                    _this.job.techAssessment = false;
                                    _this.job.techAssessmentScore = 0;
                                    _this.job.techAssessmentId = null;
                                }
                            }
                            else {
                                _this.job.techAssessment = false;
                                _this.job.techAssessmentScore = 0;
                                _this.job.techAssessmentId = null;
                            }
                        }
                        else {
                            // in add mode, if enabled, set tech assessment to true and score to the default value
                            if (_this.techAssessmentPreferences.enabled) {
                                _this.job.techAssessment = true;
                                _this.job.techAssessmentScore = val.licensePrefDetailsList[0].licensePrefMarkerValue;
                            }
                            else {
                                _this.job.techAssessment = false;
                                _this.job.techAssessmentScore = 0;
                                _this.job.techAssessmentId = null;
                            }
                        }
                        var techSliderClass_1 = '.slider-tech-assessment';
                        $(techSliderClass_1).noUiSlider({
                            range: [0, 100],
                            start: [_this.job.techAssessmentScore],
                            handles: 1,
                            connect: 'lower',
                            step: 1,
                            slide: function () {
                                var val = $(techSliderClass_1).val();
                                _this.job.techAssessmentScore = val;
                                $('#techAssessmentScoreDisplayValue').text(val).addClass('slider-bold');
                            },
                            set: function () {
                                var val = $(techSliderClass_1).val();
                                _this.job.techAssessmentScore = val;
                                $('#techAssessmentScoreDisplayValue').text(val).removeClass('slider-bold');
                            }
                        });
                        // set the value onto the intelligence score value span which displays the current value
                        $('#techAssessmentScoreDisplayValue').text(_this.job.techAssessmentScore);
                        if (!_this.techAssessmentPreferences.enabled) {
                            $('.slider-tech-assessment').attr("disabled", "disabled");
                        }
                        break;
                    case 'valueAssessmentList':
                        _this.valueAssessmentPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            value: val.licensePrefDetailsList[0].licensePrefMarkerValue,
                            company: val.licensePrefDetailsList[0].markerCompanyName,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (_this.editModeFlag) {
                            if (_this.valueAssessmentPreferences.enabled) {
                                // in edit mode, if valueAssessment value is true
                                if (!_.isNull(_this.job.licensePreferences) && _this.job.licensePreferences.valueAssessment) {
                                    _this.job.valueAssessment = true;
                                }
                                else {
                                    _this.job.valueAssessment = false;
                                    _this.job.valueAssessmentId = null;
                                }
                            }
                            else {
                                _this.job.valueAssessment = false;
                                _this.job.valueAssessmentId = null;
                            }
                        }
                        else {
                            // in add mode, if enabled, set value assessment to true
                            if (_this.valueAssessmentPreferences.enabled) {
                                _this.job.valueAssessment = true;
                            }
                            else {
                                _this.job.valueAssessment = false;
                                _this.job.valueAssessmentId = null;
                            }
                        }
                        break;
                    case 'verificationList':
                        _this.verificationPreferences = {};
                        angular.forEach(val.licensePrefDetailsList, function (v, k) {
                            switch (v['licensePrefEnum']) {
                                case 'EDUCATION_VERIFICATION':
                                    _this.verificationPreferences.educationVerificationName = v.name;
                                    _this.verificationPreferences.educationVerificationEnabled = (v.enabled && v.selected);
                                    _this.verificationPreferences.educationVerificationMessage = v.message;
                                    _this.verificationPreferences.isCandidatesPresentOnStepEducationVerification = v.candidatesPresentOnStep;
                                    _this.verificationPreferences.candidatesPresentMessageEducationVerification = v.messageForCandidatePresent;
                                    if (_this.verificationPreferences.educationVerificationEnabled) {
                                        // edit mode and license preferences have been defined already
                                        if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                            _this.job.eduVerification = _this.job.licensePreferences.educationVerification;
                                        }
                                        else {
                                            _this.job.eduVerification = true;
                                        }
                                    }
                                    else {
                                        _this.job.eduVerification = false;
                                    }
                                    break;
                                case 'EXPERIENCE_VERIFICATION':
                                    _this.verificationPreferences.experienceVerificationName = v.name;
                                    _this.verificationPreferences.experienceVerificationEnabled = (v.enabled && v.selected);
                                    _this.verificationPreferences.experienceVerificationMessage = v.message;
                                    _this.verificationPreferences.isCandidatesPresentOnStepExperienceVerification = v.candidatesPresentOnStep;
                                    _this.verificationPreferences.candidatesPresentMessageExperienceVerification = v.messageForCandidatePresent;
                                    if (_this.verificationPreferences.experienceVerificationEnabled) {
                                        if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                            _this.job.expVeification = _this.job.licensePreferences.experienceVerification;
                                        }
                                        else {
                                            _this.job.expVeification = true;
                                        }
                                    }
                                    else {
                                        _this.job.expVeification = false;
                                    }
                                    break;
                            }
                        });
                        break;
                    case 'phoneScreenList':
                        _this.phoneScreenPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (_this.phoneScreenPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                _this.job.phoneScreen = _this.job.licensePreferences.phoneScreen;
                            }
                            else {
                                _this.job.phoneScreen = true;
                            }
                        }
                        else {
                            _this.job.phoneScreen = false;
                        }
                        break;
                    case 'interviewList':
                        _this.interviewPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (_this.interviewPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                _this.job.interview = _this.job.licensePreferences.interview;
                            }
                            else {
                                _this.job.interview = true;
                            }
                        }
                        else {
                            _this.job.interview = false;
                        }
                        break;
                    case 'licenseAssessmentPreferences':
                        _this.imageProctoringPreferences = {
                            name: 'Image Proctoring',
                            enabled: (val.imageProctoringEnabled && val.imageProctoring),
                            message: val.imageProctoringMessage,
                        };
                        _this.addImagesToReportPreferences = {
                            name: 'Add Proctoring Images to Report',
                            enabled: (val.addProctoringImagesToReportEnabled && val.addProctoringImagesToReport),
                            message: val.addProctoringImagesToReportMessage
                        };
                        if (_this.imageProctoringPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                _this.job.imageProctoring = _this.job.licensePreferences.imageProctoring;
                            }
                            else {
                                _this.job.imageProctoring = true;
                            }
                        }
                        else {
                            _this.job.imageProctoring = false;
                        }
                        if (_this.addImagesToReportPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                _this.job.addProctoringImagesToReport = _this.job.licensePreferences.addProctoringImagesToReport;
                            }
                            else {
                                _this.job.addProctoringImagesToReport = true;
                            }
                        }
                        else {
                            _this.job.addProctoringImagesToReport = false;
                        }
                        break;
                    case 'recruiterScreening':
                        _this.recruiterScreeningPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: (val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected),
                            message: val.licensePrefDetailsList[0].message,
                            isCandidatesPresentOnStep: val.licensePrefDetailsList[0].candidatesPresentOnStep,
                            candidatesPresentMessage: val.licensePrefDetailsList[0].messageForCandidatePresent
                        };
                        if (_this.recruiterScreeningPreferences.enabled) {
                            // edit mode and license preferences have been defined already
                            if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                _this.job.recruiterScreening = _this.job.licensePreferences.recruiterScreening;
                            }
                            else {
                                _this.job.recruiterScreening = true;
                            }
                        }
                        else {
                            _this.job.recruiterScreening = false;
                        }
                        break;
                    case 'autoMatch':
                        var enabledFlag = val.licensePrefDetailsList[0].enabled && val.licensePrefDetailsList[0].selected;
                        _this.autoMatchingPreferences = {
                            name: val.licensePrefDetailsList[0].name,
                            enabled: enabledFlag,
                            message: val.licensePrefDetailsList[0].message
                        };
                        if (enabledFlag) {
                            // edit mode and license preferences have been defined already
                            if (_this.editModeFlag && !_.isNull(_this.job.licensePreferences)) {
                                if (!_.isNull(_this.job.licensePreferences.autoMatch)) {
                                    _this.job.autoMatch = _this.job.licensePreferences.autoMatch;
                                }
                                else {
                                    _this.job.autoMatch = false;
                                }
                            }
                            else {
                                _this.job.autoMatch = true;
                                _this.job.includeCandidatesMatchingMandatoryCriteria = true;
                            }
                        }
                        else {
                            _this.job.autoMatch = false;
                        }
                    default:
                        break;
                }
                if (val !== null && val.licensePrefDetailsList !== undefined && val.licensePrefDetailsList[0].candidatesPresentOnStep) {
                    _this.candidatesPresentOnJob = val.licensePrefDetailsList[0].candidatesPresentOnStep;
                }
            });
            if (successCallback) {
                successCallback();
            }
        });
    };
    UploadReqPageController.prototype._createCountSliders = function () {
        var _this = this;
        // empty the existing sliders
        $('.slider-current-4dot5-score').empty();
        $('.slider-adjust-4dot5-score').empty();
        // create the current score slider
        var currentScoreSliderClass = '.slider-current-4dot5-score';
        $(currentScoreSliderClass).noUiSlider({
            range: [0, 100],
            start: [this.job.score],
            handles: 1,
            connect: 'lower',
            step: 1,
            slide: function () {
                var val = $(currentScoreSliderClass).val();
                $(currentScoreSliderClass).next('span').text(val).addClass('slider-bold');
            },
            set: function () {
                var val = $(currentScoreSliderClass).val();
                //this.$scope.sliderIntelligenceValue = parseFloat(val);
                //this.$scope.requisitionDetails.licensePreferenceDetails.licensePreferenceDetails.fourDotFiveIntellList.licensePrefDetailsList[0].value = this.$scope.sliderIntelligenceValue;
                $(currentScoreSliderClass).next('span').text(val).removeClass('slider-bold');
            }
        });
        // set the current score value to the display span
        $('.slider-current-4dot5-score').next('span').text(this.job.score);
        // disable the current 4dot5 score slider.
        $('.slider-current-4dot5-score').attr("disabled", "disabled");
        // create the slider to adjust the score.
        var adjustSliderClass = '.slider-adjust-4dot5-score';
        $(adjustSliderClass).noUiSlider({
            range: [0, 100],
            start: [this.job.score],
            handles: 1,
            connect: 'lower',
            step: 1,
            slide: function () {
                var val = $(adjustSliderClass).val();
                $(adjustSliderClass).next('span').text(val).addClass('slider-bold');
                _this.$timeout(function () {
                    _this.loadingAdjustedCandidatesCountFlag = true;
                }, 50);
            },
            set: function () {
                var val = $(adjustSliderClass).val();
                $(adjustSliderClass).next('span').text(val).removeClass('slider-bold');
                _this.getCandidateCount(val, 'adjustedScore');
            }
        });
        // set the current score value to the display span
        $(adjustSliderClass).next('span').text(this.job.score);
    };
    UploadReqPageController.prototype.onClientChange = function () {
        var clientOrBusWithoutNoAssociatedBus = this.clientorbulist.filter(function (clientOrBu) { return clientOrBu.id !== ""; });
        var clientOrBUId = !this.req.clientOrBU ? '' : this.req.clientOrBU.id;
        var selectedClientOrBu = _.find(clientOrBusWithoutNoAssociatedBus, { id: clientOrBUId });
        this.req.clientOrBU = angular.copy(selectedClientOrBu);
        if (this.req.clientOrBU && this.req.clientOrBU.companyType == 'Corporation') {
            this.req.isSharedClientRequisition = true;
            this._getSharedClientBus();
        }
        else {
            this.req.isSharedClientRequisition = false;
            this.req.sharedClientBuOrCorpId = null;
            this.sharedCorporateId = null;
        }
        // change the job to empty object
        // this.job = new Job();
        this.updateActionButtons();
        this.validateStepOne();
    };
    UploadReqPageController.prototype.onSharedClientChanged = function (tabNumber) {
        var _this = this;
        this.sharedCorporateId = this.req.clientOrBU.id;
        this.req.sharedClientBuOrCorpId = this.sharedClientBuOrCorp.id;
        this.job.sharedClientBuOrCorpId = this.sharedClientBuOrCorp.id;
        if (tabNumber == 2) {
            this.getPointOfContacts(function () {
                _this._setPocs();
            });
        }
        this.updateActionButtons();
        this.validateStepOne();
    };
    UploadReqPageController.prototype._getSharedClientBus = function (successCallback) {
        var _this = this;
        this.isLoadingSharedClientBus = true;
        this.companyService.getSharedClientBus(this.companyId, this.req.clientOrBU.id, function (data) {
            _this.sharedClientBus = data;
            if (_this.req.clientOrBU && _this.req.clientOrBU.companyType == 'Corporation') {
                var sharedClient = angular.copy(_this.req.clientOrBU);
                sharedClient.name = 'None';
                sharedClient.companyType = 'Corporation';
                _this.sharedClientBus.push(sharedClient);
                _this._setSharedClientBu();
            }
            _this.isLoadingSharedClientBus = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype._setSharedClientBu = function () {
        this.sharedClientBuOrCorp = _.find(this.sharedClientBus, { 'id': this.req.sharedClientBuOrCorpId });
        if (this.req.clientOrBU) {
            if (this.req.clientOrBU.companyType == 'Corporation') {
                this.sharedCorporateId = this.req.clientOrBU.id;
            }
            else {
                this.sharedCorporateId = null;
            }
        }
    };
    UploadReqPageController.prototype._setFileInUploadDropZone = function (fileName, fileSize) {
        var mockFile = {
            name: fileName,
            size: fileSize
        };
        this.reqUploadDropzone.options.addedfile.call(this.reqUploadDropzone, mockFile);
        // delete the DOM for 'remove button' option from the file in drop zone since job is now in 'open' status
        // find the remove button in the drop zone and delete it.
        $('.dz-remove').remove();
        // find the progress bar in the drop zone and delete it.
        $('.dz-progress').remove();
        // add the success tick mark onto the file
        $('.dz-file-preview.dz-preview').addClass('dz-success');
    };
    UploadReqPageController.prototype.setProfileCriteriaInfoSkills = function (profileCriteriaInfo) {
        var categorizeSkills = function (skills, skillType) {
            if (skills && skills.length > 0) {
                return skills
                    .filter(function (skill) { return skill.displayName && skill.displayName.trim() !== ''; })
                    .map(function (skill) { return (tslib_1.__assign({}, skill, { skillType: skillType })); });
            }
            return [];
        };
        profileCriteriaInfo.technicalSkills = categorizeSkills(profileCriteriaInfo.technicalSkills, 'TECHNICALSKILLS');
        profileCriteriaInfo.operationalSkills = categorizeSkills(profileCriteriaInfo.operationalSkills, 'OPERATIONALSKILLS');
        profileCriteriaInfo.otherSkills = categorizeSkills(profileCriteriaInfo.otherSkills, 'OTHERS');
        profileCriteriaInfo.softSkills = categorizeSkills(profileCriteriaInfo.softSkills, 'SOFTSKILLS');
        ['certifications', 'experiences', 'educations'].forEach(function (key) {
            profileCriteriaInfo[key] = profileCriteriaInfo[key]
                ? profileCriteriaInfo[key]
                    .filter(function (item) { return item.displayName && item.displayName.trim() !== ''; })
                    .map(function (item) { return (tslib_1.__assign({}, item)); })
                : [];
        });
    };
    // save step1 details
    UploadReqPageController.prototype.saveStep1Details = function (isRerun, successCallback, errorCallback) {
        var _this = this;
        var clientOrBUIdStepOne = !this.job.clientorbu ? null : this.job.clientorbu.id;
        this.job.profileCriteriaInfo.title = this.job.title;
        this.setProfileCriteriaInfoSkills(this.job.profileCriteriaInfo);
        var step1DetailsTempObject = {
            jobId: this.job.id,
            title: this.job.title,
            isSharedClientRequisition: this.currentJobStatus !== 'DRAFT' ? this.job.isSharedClientRequisition : this.req.isSharedClientRequisition,
            sharedClientBuOrCorpId: this.currentJobStatus !== 'DRAFT' ? this.job.sharedClientBuOrCorpId : this.req.sharedClientBuOrCorpId,
            clientOrBUId: clientOrBUIdStepOne,
            requistionNumber: this.job.requisitionNumber,
            isFutureMatchesOnly: this.isFutureMatchesOnly,
            profileCriteriaInfo: this.job.profileCriteriaInfo,
            source: this.currentJobStatus !== 'DRAFT' ? 'EDITREQ' : 'CREATEREQ',
            tab: this.currentJobStatus !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION'
        };
        step1DetailsTempObject.profileCriteriaInfo.userEnteredDescription = true;
        var updateFlag = true;
        var companyId = (this.job && this.job.company && this.job.company.id) ? this.job.company.id : this.userDetails.company.companyId;
        this.utilityService.showLoadingModal("Saving...");
        step1DetailsTempObject.rerunScore = isRerun;
        step1DetailsTempObject.recalculateLater = !isRerun;
        if (this.currentJobStatus !== 'DRAFT') {
            step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails = this.job.includeCandidatesWithNoAdditionalDetails;
            step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria = this.job.includeCandidatesMatchingMandatoryCriteria;
            step1DetailsTempObject.asyncActionType = 'async';
            step1DetailsTempObject.criteriaUpdated = this.isSkillsChanged;
            step1DetailsTempObject.flagsUpdated = this.checkIfFlagsChanged(step1DetailsTempObject, this.step1DetailsTempObject);
            this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, function (data) {
                _this.job.profileCriteriaInfo = (data && data.t) ? tslib_1.__assign({}, data.t.profileCriteriaInfo) : _this.job.profileCriteriaInfo;
                _this.job.title = (data && data.t) ? data.t.title : _this.job.title;
                _this.updateUserCache();
                _this.utilityService.hideLoadingModal();
                if (data && !data.t && data.message) {
                    var title = (!step1DetailsTempObject.rerunScore && step1DetailsTempObject.recalculateLater) ? "Job updated successfully." : "Job matching in Progress";
                    _this.alertsAndNotificationsService.showAlertWithCallBack(title, data.message, "success", function () {
                        if (step1DetailsTempObject.rerunScore && !step1DetailsTempObject.recalculateLater) {
                            _this.$state.go('missioncontrol.requisitions');
                        }
                    });
                }
                _this._createStepTempObject(1);
                if (successCallback) {
                    successCallback();
                }
            }, function (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
                _this.utilityService.hideLoadingModal();
            });
        }
        else {
            updateFlag = false;
            clientOrBUIdStepOne = this.req.clientOrBU ? this.req.clientOrBU.id : null;
            this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, function (data) {
                _this.job.profileCriteriaInfo = (data && data.t) ? tslib_1.__assign({}, data.t.profileCriteriaInfo) : _this.job.profileCriteriaInfo;
                _this.job.title = (data && data.t) ? data.t.title : _this.job.title;
                _this._createStepTempObject(1);
                if (successCallback) {
                    successCallback();
                }
                _this.updateUserCache();
                _this.utilityService.hideLoadingModal();
            }, function (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
                _this.utilityService.hideLoadingModal();
            });
        }
    };
    /**
     * save step2 details - requisition number, recruiters,job type, sponsorships
    * */
    UploadReqPageController.prototype.saveStep2Details = function (buttonType, successCallback, errorCallback) {
        var _this = this;
        if (_.isNull(this.job.sponsorships)) {
            this.job.sponsorships = [];
        }
        if (_.isNull(this.job.workLocationIds)) {
            this.job.workLocationIds = [];
        }
        var clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        var step2DetailsObject = {
            jobId: this.job.id,
            title: this.job.title,
            isSharedClientRequisition: this.job.isSharedClientRequisition,
            sharedClientBuOrCorpId: this.job.sharedClientBuOrCorpId,
            clientOrBUId: clientOrBUId,
            requistionNumber: this.job.requisitionNumber,
            openings: this.job.openings,
            jobType: this.job.jobType,
            contractDuration: this.job.contractDuration,
            requisitionNote: this.job.requisitionNote,
            jobSalary: angular.copy(this.job.jobSalary),
            sponsorships: this.job.sponsorships,
            sponsorshipProvided: this.job.sponsorshipProvided,
            workLocationIds: this.job.workLocationIds,
            recruiters: this.job.recruiters,
            hiringManagers: angular.copy(this.job.hiringManagers),
            vendorIds: this.job.vendorIds,
            pointOfContactUserId: this.job.pointOfContactUserId,
            tab: "ASSIGN_RECRUITERS",
            endClientId: this.job.endClientId
        };
        var updateFlag = (this.step2DetailsSavedFlag && (this.currentJobStatus == 'OPEN'));
        step2DetailsObject.actionType = this.editModeFlag ? "UPDATE" : "ADD";
        step2DetailsObject.source = this.editModeFlag ? "EDITREQ" : "CREATEREQ";
        if (this.isAsyncProcess && this.currentJobStatus !== 'DRAFT') {
            this.isUiCanExit = true;
            step2DetailsObject.asyncActionType = buttonType;
            this.jobService.createUpdateJobDetails(updateFlag, step2DetailsObject, this.job.company.id, clientOrBUId, this.userDetails.id, function (data) {
                // Refresh requisition 
                _this.updateRequisitionIcons(data.t);
            }, function () { });
            this.savingFlag = false;
            this.utilityService.hideLoadingModal();
            var message_2 = "Job match process has started in the background and will inform all users on the Requisition when its completed.";
            if (this.isRecalcucateScoreNoClicked) {
                this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', function () {
                    _this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message_2, "success", function () {
                        _this.$state.go('missioncontrol.requisitions');
                    });
                });
            }
            else {
                this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message_2, "success", function () {
                    _this.$state.go('missioncontrol.requisitions');
                });
            }
            this.updateUserCache();
        }
        else {
            this.jobService.createUpdateJobDetails(updateFlag, step2DetailsObject, this.job.company.id, clientOrBUId, this.userDetails.id, function (data) {
                _this.updateRequisitionIcons(data.t);
                _this.editTitleFlag = false;
                _this.editBUFlag = false;
                if (!clientOrBUId) {
                    _this.req.clientOrBU = null;
                }
                else {
                    angular.forEach(_this.clientorbulist, function (val, key) {
                        if (val.id == _this.job.clientorbu.id) {
                            _this.req.clientOrBU = val;
                        }
                    });
                }
                _this.step2DetailsSavedFlag = true;
                if (successCallback) {
                    successCallback();
                }
                _this.updateUserCache();
            }, function (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
            });
        }
    };
    /**
     * update the job's location
     */
    UploadReqPageController.prototype.updateLocation = function () {
        var vm = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            template: UploadReqUpdateLocationModalTemplate.default,
            controller: ['$uibModalInstance', 'jobId', 'location', function ($uibModalInstance, jobId, location) {
                    var _this = this;
                    this.jobId = jobId;
                    this.location = location;
                    this.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    this.clearLocation = function () {
                        vm.job.locationLabel = "";
                        vm.job.location = null;
                        vm.isJobLocationChanged = true;
                        _this.closeModal();
                    };
                    this.saveCallback = function (locationObject) {
                        _this.closeModal();
                        vm.isJobLocationChanged = true;
                        vm.updateLocationCallback(locationObject);
                    };
                }],
            controllerAs: 'updateLocationModal',
            size: 'lg',
            resolve: {
                jobId: function () {
                    return vm.job.id;
                },
                location: function () {
                    var locationObject = angular.copy(vm.job.location);
                    // locationObject.city = _.isNull(locationObject.city) ? null: locationObject.city.name;
                    return locationObject;
                }
            }
        });
    };
    UploadReqPageController.prototype.updateLocationCallback = function (locationObject) {
        // update the location label
        this.job.locationLabel = locationObject.city + ', ' + locationObject.state + ', ' + locationObject.zipCode;
        //let cityName = locationObject.city;
        //locationObject.city = {};
        //locationObject.city.name = cityName;
        this.job.location = locationObject;
    };
    /**
     *
     * save the workflow steps
     *
     */
    UploadReqPageController.prototype.saveWorkflowSteps = function (isRerun, successCallback, errorCallback) {
        var _this = this;
        var workflowStepsObject = {
            jobId: this.job.id,
            score: this.job.score,
            autoMatch: this.job.autoMatch,
            recruiterScreening: this.job.recruiterScreening,
            techAssessmentId: this.job.techAssessmentId,
            techAssessmentScore: this.job.techAssessmentScore,
            techAssessment: this.job.techAssessment,
            valueAssessmentId: this.job.valueAssessmentId,
            valueAssessment: this.job.valueAssessment,
            eduVerification: this.job.eduVerification,
            expVeification: this.job.expVeification,
            phoneScreen: this.job.phoneScreen,
            interview: this.job.interview,
            imageProctoring: this.job.imageProctoring,
            addProctoringImagesToReport: this.job.addProctoringImagesToReport,
            workflowStepsOrder: angular.copy(this.job.workflowStepsOrder),
            includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
            includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria,
            // jobBoardDetails: this.job.jobBoardDetails,
            // resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
            tab: "WORKFLOW_STEPS"
        };
        var updateFlag = (this.workflowStepsSavedFlag && (this.currentJobStatus == 'OPEN'));
        var clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        workflowStepsObject.actionType = this.editModeFlag ? "UPDATE" : "ADD";
        workflowStepsObject.source = this.editModeFlag ? "EDITREQ" : "CREATEREQ";
        var flagsUpdated = this.checkIfFlagsChanged(workflowStepsObject, this.workflowStepsTempObject);
        if (flagsUpdated) {
            workflowStepsObject.asyncActionType = this.currentJobStatus != 'DRAFT' ? 'async' : null;
            workflowStepsObject.criteriaUpdated = false;
            workflowStepsObject.flagsUpdated = flagsUpdated;
            workflowStepsObject.rerunScore = isRerun;
            workflowStepsObject.recalculateLater = !isRerun;
        }
        this.jobService.createUpdateJobDetails(updateFlag, workflowStepsObject, this.job.company.id, clientOrBUId, this.userDetails.id, function (data) {
            // Refresh requisition icons
            _this.updateRequisitionIcons(data.t);
            _this.workflowStepsSavedFlag = true;
            _this.isLicensePreferenceSet = true;
            if (flagsUpdated && _this.currentJobStatus != 'DRAFT') {
                var title = (!workflowStepsObject.rerunScore && workflowStepsObject.recalculateLater) ? "Job updated successfully." : "Job matching in Progress";
                _this.alertsAndNotificationsService.showAlertWithCallBack(title, data.message, "success", function () {
                    if (workflowStepsObject.rerunScore && !workflowStepsObject.recalculateLater) {
                        _this.$state.go('missioncontrol.requisitions');
                    }
                });
            }
            if (successCallback) {
                successCallback();
            }
            _this.updateUserCache();
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    };
    UploadReqPageController.prototype._updateDataAfterWorkflowStepsSaved = function (isRerun, currentStep, successCallback, errorCallback) {
        var _this = this;
        this.disableAllButtonsFlag = true;
        this.savingFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveWorkflowSteps(isRerun, function () {
            _this.utilityService.hideLoadingModal();
            _this.disableAllButtonsFlag = false;
            _this.savingFlag = false;
            // show the message that the job is saved state
            if (_this.$rootScope.isOnline) {
                var successMessage = 'The Requisition details have been saved in Draft Status.';
                if (_this.currentJobStatus == 'OPEN') {
                    successMessage = 'The Requisition details have been saved.';
                }
                _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
            }
            _this._createStepTempObject(currentStep);
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.utilityService.hideLoadingModal();
            _this.disableAllButtonsFlag = false;
            _this.savingFlag = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    UploadReqPageController.prototype._updateDataAfterWorkflowStepsSavedNextClicked = function (isRerun, data, successCallback, errorCallback) {
        var _this = this;
        this.step3RequestWasInProgressFlag = true;
        this.utilityService.showLoadingModal("Saving...");
        this.saveWorkflowSteps(isRerun, function () {
            // if (this.currentJobStatus === "DRAFT") {
            //             $("#uploadReqWizard").wizard('next');
            // }else{
            _this.getJobBoardParameters(function () {
                _this.getRadiusAndRecencyOptions(function () {
                    _this._createStepTempObject(data.step + 1);
                    _this.utilityService.hideLoadingModal();
                    if (successCallback) {
                        successCallback();
                    }
                }, function (error) {
                    _this._enableStepActionsOnWizard(data.step);
                    _this.utilityService.hideLoadingModal();
                    // show error messages
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    if (errorCallback) {
                        errorCallback();
                    }
                    // no move to next step
                });
            }, function (error) {
                _this._enableStepActionsOnWizard(data.step);
                _this.utilityService.hideLoadingModal();
                // show error messages
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                if (errorCallback) {
                    errorCallback();
                }
                // no move to next step
            });
            //  }
        }, function (error) {
            _this._enableStepActionsOnWizard(data.step);
            _this.utilityService.hideLoadingModal();
            // show error messages
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
            // no move to next step
        });
    };
    /**
     *
     * save the Job boards settings
     *
     */
    UploadReqPageController.prototype.saveJobBoardsSettings = function (buttonType, successCallback, errorCallback) {
        var _this = this;
        this.utilityService.showLoadingModal("Saving...");
        var jobBoardsObject = {
            jobId: this.job.id,
            score: this.job.score,
            autoMatch: this.job.autoMatch,
            jobBoardDetails: this.job.jobBoardDetails,
            resumesToPullPerJobBoardCount: this.job.resumesToPullPerJobBoardCount,
            isResumePullEnabled: this.job.isResumePullEnabled,
            radius: this.job.radius,
            recency: this.job.recency,
            buttonType: buttonType,
            tab: "JOB_BOARDS"
        };
        var updateFlag = (this.jobBoardsSettingsSavedFlag && (this.currentJobStatus == 'OPEN'));
        var clientOrBUId = !this.job.clientorbu ? null : this.job.clientorbu.id;
        jobBoardsObject.actionType = this.editModeFlag ? "UPDATE" : "ADD";
        jobBoardsObject.source = this.editModeFlag ? "EDITREQ" : "CREATEREQ";
        this.jobService.createUpdateJobDetails(updateFlag, jobBoardsObject, this.job.company.id, clientOrBUId, this.userDetails.id, function (data) {
            _this.jobBoardsSettingsSavedFlag = true;
            _this.isJobBoardDetailsSet = true;
            if (successCallback) {
                successCallback();
            }
            _this.utilityService.hideLoadingModal();
            _this.updateUserCache();
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
            _this.utilityService.hideLoadingModal();
        });
    };
    /**
     * save the adjusted 4dot5 intelligence score
     */
    UploadReqPageController.prototype.saveAdjusted4dot5Score = function (score, successCallback, errorCallback) {
        var _this = this;
        this.utilityService.showLoadingModal("Saving...");
        var saveObject = {
            jobId: this.job.id,
            score: score,
            candidatesToMatch: this.currentScoreCandidateCounts.candidatesToMatch
        };
        this.jobService.update4dot5Score(saveObject, function (data) {
            _this.job.score = score;
            _this.getCandidateCount(_this.job.score, 'currentScore', function () {
                _this._createCountSliders();
                _this.utilityService.hideLoadingModal();
                if (successCallback) {
                    successCallback(data);
                }
            });
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
            _this.utilityService.hideLoadingModal();
        });
    };
    /**
     *  save the job details
     */
    UploadReqPageController.prototype.saveJob = function (successCallback, errorCallback) {
        var _this = this;
        var jobSaveObject = {};
        jobSaveObject.id = this.job.id;
        jobSaveObject.requisitionNumber = this.job.requisitionNumber;
        jobSaveObject.recruiters = this.job.recruiters;
        jobSaveObject.hiringManagers = angular.copy(this.job.hiringManagers);
        jobSaveObject.jobType = 'FULLTIME';
        jobSaveObject.jobSalary = angular.copy(this.job.jobSalary);
        this.jobService.saveJob(jobSaveObject, function (data) {
            _this.job = data;
            successCallback();
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            errorCallback();
        });
    };
    /**
     * set job status to open
     */
    UploadReqPageController.prototype.setJobStatusToOpen = function (successCallback, errorCallback) {
        var _this = this;
        this.jobService.setJobStatusToOpen(this.job.id, function (data) {
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    /**
     * run job for scoring
     */
    UploadReqPageController.prototype.runJobForScoring = function (successCallback, errorCallback) {
        var _this = this;
        this.jobService.runJobForScoring(this.job.company.id, this.job.id, this.job.transactionId, function (data) {
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    /**
     * get Candidates Count
     */
    UploadReqPageController.prototype.getCandidateCount = function (score, scoreType, successCallback, errorCallback) {
        var _this = this;
        if (scoreType == 'adjustedScore') {
            this.loadingAdjustedCandidatesCountFlag = true;
        }
        var isNew = this.isInitialStateDraft;
        this.jobService.getCandidateCount(this.job.id, score, this.job.transactionId, isNew, function (data) {
            if (scoreType == 'currentScore') {
                // set both the current score and adjusted score candidate counts
                _this.currentScoreCandidateCounts = data;
                _this.adjustedScoreCandidateCounts = data;
            }
            else if (scoreType == 'adjustedScore') {
                // set only the adjusted score candidate counts
                _this.adjustedScoreCandidateCounts = data;
                _this.loadingAdjustedCandidatesCountFlag = false;
            }
            if (successCallback) {
                successCallback(data);
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback(error);
            }
        });
    };
    /**
     * get candidates by requisition transaction
     */
    UploadReqPageController.prototype.getCandidatesByRequisitionTransaction = function (countType, scoreType) {
        this.candidatesBasedOnRequisitionTransaction = [];
        var score = this.job.score;
        if (scoreType == 'adjustedScore') {
            // set the adjusted score
            score = $('.slider-adjust-4dot5-score').val();
        }
        var vm = this;
        this.candidateCardNotesModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-large',
            template: UploadReqTransactionsCandidateModalTemplate.default,
            controller: ['$uibModalInstance', 'jobId', 'jobScore', 'score', 'transactionId', 'countType', 'clientOrBuLabel', 'jobService', 'candidateService', 'alertsAndNotificationsService', function ($uibModalInstance, jobId, jobScore, score, transactionId, countType, clientOrBuLabel, jobService, candidateService, alertsAndNotificationsService) {
                    var _this = this;
                    this.candidates = [];
                    this.jobScore = jobScore;
                    this.clientOrBuLabel = clientOrBuLabel;
                    this.loadingFlag = true;
                    this.jobService = jobService;
                    this.candidateService = candidateService;
                    this.alertsAndNotificationsService = alertsAndNotificationsService;
                    // functions
                    this.init = init;
                    this.getCandidateJobMatches = getCandidateJobMatches;
                    this.closeModal = closeModal;
                    this.init = function () {
                        _this.jobService.getCandidatesByRequisitionTransaction(jobId, vm.companyId, score, transactionId, countType, function (data) {
                            _this.candidates = data;
                            angular.forEach(_this.candidates, function (val, key) {
                                val.name = val.firstName;
                                if (!_.isNull(val.lastName)) {
                                    val.name += " " + val.lastName;
                                }
                                val.candidateJobMatches = [];
                                if (_.isUndefined(val.currentJobScore)) {
                                    val.currentJobScore = 0;
                                }
                                if (val.currentJobScore == 0) {
                                    val.currentJobScore = 'N/A';
                                }
                                else {
                                    val.intelligenceScorePassFlag = false;
                                    if (val.currentJobScore >= _this.jobScore) {
                                        val.intelligenceScorePassFlag = true;
                                    }
                                    // round the match score to the lower integer value.
                                    val.currentJobScore = Math.floor(parseFloat(val.currentJobScore));
                                }
                                var cardPosition = key % 4;
                                switch (cardPosition) {
                                    case 0:
                                        val.jobMatchesPopoverPosition = 'bottom-left';
                                        break;
                                    case 1:
                                        val.jobMatchesPopoverPosition = 'bottom';
                                        break;
                                    case 2:
                                        val.jobMatchesPopoverPosition = 'bottom';
                                        break;
                                    case 3:
                                        val.jobMatchesPopoverPosition = 'bottom-right';
                                        break;
                                }
                                _this.getCandidateJobMatches(val.id, function (data) {
                                    val.candidateJobMatches = data;
                                });
                            });
                            _this.loadingFlag = false;
                        }, function (error) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            _this.loadingFlag = false;
                        });
                    };
                    this.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                    this.getCandidateJobMatches = function (candidateId, successCallback) {
                        var candidateJobMatches = [];
                        var jobMatchesObject = new JobMatchQueryFilter();
                        jobMatchesObject.candidateId = candidateId;
                        jobMatchesObject.userId = _this.userId;
                        jobMatchesObject.companyId = _this.companyId;
                        jobMatchesObject.top5Flag = true;
                        jobMatchesObject.candidateType = 'OWN_CANDIDATES';
                        jobMatchesObject.searchText = '';
                        jobMatchesObject.vendorIds = [];
                        _this.candidateService.getCandidateJobMatches(jobMatchesObject, '', '', function (data) {
                            angular.forEach(data, function (val, key) {
                                val.jobMatchDate = new Date(val.jobMatchDate);
                                if (_.isNull(val.fourDotFiveIntelligentScore)) {
                                    val.fourDotFiveIntelligentScore = 'N/A';
                                }
                                candidateJobMatches.push(val);
                            });
                            if (successCallback) {
                                successCallback(candidateJobMatches);
                            }
                        }, function (error) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    };
                    this.init();
                }],
            controllerAs: 'candidatesModal',
            size: 'lg',
            resolve: {
                jobId: function () {
                    return vm.job.id;
                },
                score: function () {
                    return score;
                },
                jobScore: function () {
                    return vm.job.score;
                },
                transactionId: function () {
                    return vm.job.transactionId;
                },
                countType: function () {
                    return countType;
                },
                clientOrBuLabel: function () {
                    return vm.clientOrBuLabel;
                }
            }
        });
    };
    /**
     * update the action buttons
     */
    UploadReqPageController.prototype.updateActionButtons = function () {
        var _this = this;
        var wizardCurrentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        switch (wizardCurrentStep) {
            case 1:
                this.isStepOneActive = true;
                this.isClientOrBuRequired = false;
                if (this.clientOrBUIsRequiredFlag) { //Client
                    // if - client is chosen and file exists in drop zone and there is no job id
                    // Enable the upload button
                    if (this.req.clientOrBU && angular.isDefined(this.req.clientOrBU) && angular.isDefined(this.req.clientOrBU.id) && this.fileExistsFlag && ((!_.isNull(this.job)) && (_.isNull(this.job.id))) && (this.req.clientOrBU.companyType !== 'Corporation' || (this.req.clientOrBU.companyType == 'Corporation' && !_.isNull(this.req.sharedClientBuOrCorpId)))) {
                        this.disableUploadButtonFlag = false;
                    }
                    else if (this.fileExistsFlag && (!this.req.clientOrBU || !this.req.clientOrBU.id)) {
                        this.isClientOrBuRequired = true;
                        this.disableUploadButtonFlag = true;
                    }
                    else {
                        if (this.req.clientOrBU && this.req.clientOrBU.id) {
                            this.disableNextButtonFlag = false;
                        }
                        this.disableUploadButtonFlag = true;
                    }
                }
                else { //BU
                    if ((this.req.clientOrBU || this.isAssociatedBuSelected()) && (this.fileExistsFlag && ((!_.isNull(this.job)) && (_.isNull(this.job.id))))) {
                        this.disableUploadButtonFlag = false;
                    }
                    else if (!this.req.clientOrBU && this.clientorbulist.filter(function (clientOrBu) { return clientOrBu.id === ""; }).length == 0) {
                        this.isClientOrBuRequired = true;
                        this.disableUploadButtonFlag = true;
                    }
                    else {
                        this.disableUploadButtonFlag = true;
                    }
                }
                // // save button is always disabled in this step
                // this.disableSaveButtonFlag = true;
                // // if job is defined, that means an upload was done for current client. Hence the next button should be enabled.
                if (angular.isDefined(this.job.id) && this.job.id != null) {
                    // enable the next button
                    this.disableNextButtonFlag = false;
                    // For Edit requisitions detials screen
                    this.disableSaveButtonFlag = false;
                }
                else {
                    // disable the next button
                    if ((!this.isUploadRequisition && (this.isCorporate || (this.req.clientOrBU && this.req.clientOrBU.id)))) {
                        this.disableNextButtonFlag = false;
                    }
                    else {
                        this.disableNextButtonFlag = true;
                    }
                }
                break;
            case 2:
                this.isStepOneActive = false;
                this.disableSaveButtonFlag = false;
                break;
            case 3:
                this.disableSaveButtonFlag = false;
                break;
            case 6:
                this.disableSaveButtonFlag = false;
                break;
            default:
                break;
        }
        this.$timeout(function () {
            _this.$scope.$apply();
        }, 200);
    };
    UploadReqPageController.prototype.isAssociatedBuSelected = function () {
        return !this.req.clientOrBU && this.clientorbulist.filter(function (clientOrBu) { return clientOrBu.id === ""; }).length > 0;
    };
    /**
     * Process the file queue in the drop zone and upload the requisition
     */
    UploadReqPageController.prototype.uploadRequisition = function () {
        this.reqUploadDropzone.processQueue();
    };
    UploadReqPageController.prototype.launchAdvancedJobBoardSearch = function () {
        this.candidateCardNotesModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            templateUrl: 'app/partials/missioncontrol/uploadreq/upload-req-advanced-job-search-modal.html',
            controller: ['$uibModalInstance', 'requisitionService', 'alertsAndNotificationsService', function ($uibModalInstance, requisitionService, alertsAndNotificationsService) {
                    var _this = this;
                    var vm = this;
                    this.loadingFlag = true;
                    this.requisitionService = requisitionService;
                    this.alertsAndNotificationsService = alertsAndNotificationsService;
                    this.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                    this.requisitionService.getJobBoardsAdvancedSearchInterface({}, function (data) {
                        _this.loadingFlag = false;
                        _this.jobBoardResponseHTML = _this.$sce.trustAsHtml(data.html);
                        _this.jobBoardResponseCSS = data.libs.css;
                        _this.jobBoardResponseParamsJS = data.libs.jb_params_jq;
                        _this.jobBoardResponseJS = data.js;
                    }, function (error) {
                        _this.loadingFlag = false;
                        if (_this.$rootScope.isOnline) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }],
            controllerAs: 'jobBoardSearchModal',
            size: 'lg'
        });
    };
    UploadReqPageController.prototype.useJobBoardChange = function () {
        if (!this.job.isResumePullEnabled) {
            // this.job.jobBoardDetails = angular.copy(this.jobBoardDetailsCopy);
        }
    };
    UploadReqPageController.prototype.getResumesFromJobBoards = function (saveCallback, errorCallback) {
        this.jobService.getResumesFromJobBoards(this.job.id, this.job.jobBoardDetails, this.job.resumesToPullPerJobBoardCount, this.job.radius, this.job.recency, function (data) {
            if (saveCallback) {
                saveCallback();
            }
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    };
    UploadReqPageController.prototype.onActivateRequisitionSwitchChange = function () {
        this.disableNextButtonFlag = this.isActivateRequisitionEnabled ? false : true;
    };
    UploadReqPageController.prototype.onJobBoardSelectionChange = function () {
        var _this = this;
        this.isJobBoardSelected = false;
        angular.forEach(this.job.jobBoardDetails, function (val, key) {
            if (val.enabled == true) {
                _this.isJobBoardSelected = true;
            }
        });
    };
    UploadReqPageController.prototype.onSalaryTypeChange = function (salaryType) {
        if (this.job.jobSalary.salaryDuration == undefined) {
            this.job.jobSalary = new JobSalary();
            this.job.jobSalary.currency = "USD";
            this.job.jobSalary.salaryType = salaryType;
            this._setSalaryRangeOptions();
        }
        if (!this.job.jobSalary.currency) {
            this.job.jobSalary.currency = "USD";
        }
    };
    UploadReqPageController.prototype.onStepSelectionChange = function (stepStatus, stepDetails, verificationStepName) {
        var showWarningMessage = false;
        if (stepDetails.isCandidatesPresentOnStep && !stepStatus && verificationStepName == undefined) {
            switch (stepDetails.name) {
                case "Recruiter Screening":
                    this.job.recruiterScreening = true;
                    showWarningMessage = true;
                    break;
                case "Tech Assessment":
                    this.job.techAssessment = true;
                    showWarningMessage = true;
                    break;
                case "Value Assessment":
                    this.job.valueAssessment = true;
                    showWarningMessage = true;
                    break;
                case "Phone Screen":
                    this.job.phoneScreen = true;
                    showWarningMessage = true;
                    break;
                case "Interview":
                    this.job.interview = true;
                    showWarningMessage = true;
                    break;
            }
            if (showWarningMessage) {
                this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessage, stepDetails.name);
            }
        }
        if (verificationStepName == "Education Verification" && stepDetails.isCandidatesPresentOnStepEducationVerification && !stepStatus) {
            this.job.eduVerification = true;
            this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessageEducationVerification, stepDetails.name);
        }
        if (verificationStepName == "Experience Verification" && stepDetails.isCandidatesPresentOnStepExperienceVerification && !stepStatus) {
            this.uploadReq.job.expVeification = true;
            this._showCandidatesAvailableOnStepWarning(stepDetails.candidatesPresentMessageExperienceVerification, stepDetails.name);
        }
        this.validateStepThree();
        this._massageWorkflowStepsOrder();
    };
    UploadReqPageController.prototype._showCandidatesAvailableOnStepWarning = function (message, stepName) {
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UploadReqWorkflowStepWarningModalTemplate.default,
            backdrop: 'static',
            controller: ['$uibModalInstance', 'message', 'stepName', function ($uibModalInstance, message, stepName) {
                    var vm = this;
                    this.message = message;
                    this.stepName = stepName;
                    this.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
            controllerAs: 'warningModal',
            size: 'sm',
            windowTopClass: 'four-dot-five-modal-small',
            resolve: {
                message: function () {
                    return message;
                },
                stepName: function () {
                    return stepName;
                }
            }
        });
    };
    UploadReqPageController.prototype._showcandidatesPresentOnJobWarningMessage = function (successCallback) {
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: 'Cannot change the Job Type as candidate(s) exist in the Requisition!',
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: function () {
                if (successCallback) {
                    successCallback();
                }
            }
        });
    };
    UploadReqPageController.prototype.showJobProfile = function () {
        var vm = this;
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UploadReqJobProfileModalTemplate.default,
            backdrop: 'static',
            controller: ['$uibModalInstance', 'jobId', function ($uibModalInstance, jobId) {
                    var vm = this;
                    this.jobId = jobId;
                    this.modalHeading = 'Job Profile';
                    this.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
            controllerAs: 'jobProfileModal',
            size: 'lg',
            windowTopClass: 'four-dot-five-modal-large',
            resolve: {
                jobId: function () {
                    return vm.job.id;
                }
            }
        });
    };
    UploadReqPageController.prototype._setEndClient = function (tempObj) {
        this.endClient = tempObj.endClient ? [tempObj.endClient] : null;
        tempObj.endClientId = tempObj.endClient ? tempObj.endClient.id : null;
    };
    UploadReqPageController.prototype._addEditEndClient = function (type, endClientName, successCallback) {
        var _this = this;
        if (type === 'Add') {
            var tempEndClient = {};
            this.endClient = null;
            tempEndClient = {
                companyId: this.companyId,
                name: endClientName
            };
            this.jobService.addEndClient(this.userId, tempEndClient, function (data) {
                if (data) {
                    var message = type + "ed End Client Successfully.";
                    _this.alertsAndNotificationsService.showBannerMessage(message, 'success');
                    _this.endClient = [{
                            companyId: data.companyId,
                            name: data.name,
                            id: data.id
                        }];
                    _this.job.endClientId = data.id;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else if (type === 'Edit') {
            var endClientCopy_1 = angular.copy(this.endClient);
            var tempEndClient = {};
            tempEndClient.id = endClientCopy_1[0].id;
            tempEndClient.name = endClientName;
            tempEndClient.companyId = endClientCopy_1[0].companyId ? endClientCopy_1[0].companyId : this.companyId;
            this.endClient = null;
            this.jobService.editEndClient(this.userId, this.job.id, tempEndClient, function (data) {
                if (data) {
                    _this.endClient = null;
                    _this.endClient = [{
                            companyId: data.companyId,
                            name: data.name,
                            id: data.id,
                            associatedReqDetails: data.associatedReqDetails
                        }];
                    _this.job.endClientId = data.id;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, function (error) {
                _this.endClient = endClientCopy_1;
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else if (type === 'Delete') {
            this.jobService.deleteEndClient(this.endClient[0].id, function (data) {
                if (data) {
                    var message = type + "d End Client Successfully.";
                    _this.alertsAndNotificationsService.showBannerMessage(message, 'success');
                    _this.endClient = null;
                    _this.job.endClientId = null;
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    UploadReqPageController.prototype.addEditEndClient = function (type) {
        this.endClientSearchText = type === 'Add' ? "" : this.endClientSearchText;
        this.isManageEndClient = (type === 'Manage' && this.endClient) ? true : false;
        if (type === 'Edit' || type === 'Delete') {
            this.isManageEndClient = false;
            this.addEditClientName = angular.copy(this.endClient[0].name);
            if (type === 'Delete') {
                this.associatedEdClientReqDetails = angular.copy(this.endClient[0].associatedReqDetails);
            }
            else {
                this.associatedEdClientReqDetails = [];
            }
        }
        else {
            this.addEditClientName = "";
        }
        if (type === 'Add' || type === 'Edit' || type === 'Delete') {
            var vm_1 = this;
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                template: UploadReqAddEditEndClientTemplate.default,
                controller: ['$uibModalInstance', 'type', 'addEditClientName', 'isEndClientNameValid', 'endClientDetails', function ($uibModalInstance, type, addEditClientName, isEndClientNameValid, endClientDetails) {
                        var _this = this;
                        this.type = type;
                        this.addEditClientName = addEditClientName;
                        this.isEndClientNameValid = isEndClientNameValid;
                        this.endClientDetails = endClientDetails;
                        this.closeModal = function () {
                            $uibModalInstance.close('cancel');
                        };
                        this.saveCallback = function (type, addEditClientName) {
                            vm_1.addEditClientName = addEditClientName;
                            if (addEditClientName.length > 0) {
                                vm_1.isEndClientNameValid = false;
                                vm_1._addEditEndClient(type, addEditClientName, function () {
                                    _this.closeModal();
                                });
                            }
                            else {
                                vm_1.isEndClientNameValid = true;
                            }
                        };
                    }],
                controllerAs: 'addEditModal',
                windowTopClass: 'four-dot-five-modal-extra-small',
                resolve: {
                    type: function () {
                        return type;
                    },
                    addEditClientName: function () {
                        return vm_1.addEditClientName;
                    },
                    isEndClientNameValid: function () {
                        return vm_1.isEndClientNameValid;
                    },
                    endClientDetails: function () {
                        return vm_1.associatedEdClientReqDetails;
                    }
                }
            });
        }
    };
    UploadReqPageController.prototype.getEndClientTypeAhead = function (searchTerm) {
        return this.jobService.getEndClients(this.companyId, this.job.id, searchTerm).then(function (data) {
            return data;
        });
    };
    UploadReqPageController.prototype.endClientTypeAheadTagAdded = function (tag) {
        this.addEditClientName = tag.name;
        if (tag.id) {
            this.job.endClientId = tag.id;
        }
    };
    UploadReqPageController.prototype.endClientTypeAheadTagRemoved = function (tag) {
        this.isManageEndClient = false;
        this.endClient = null;
        this.job.endClientId = null;
    };
    UploadReqPageController.prototype.sendOutreachEmailToCandidates = function (candidateIds) {
        var _this = this;
        var candidateIdsAndCandidateTypes = [];
        if (candidateIds && candidateIds.length > 0) {
            candidateIds.forEach(function (candidateId) {
                candidateIdsAndCandidateTypes.push({
                    id: candidateId,
                    candidateType: "OWN_CANDIDATES"
                });
            });
        }
        if (this.isOutreachEnabled && this.sendOutreachEmail && candidateIds && candidateIdsAndCandidateTypes.length > 0) {
            var outreachObject = {
                candidates: candidateIdsAndCandidateTypes,
                userId: this.userId,
                companyId: this.companyId,
                clientOrBuId: this.currentJobStatus != 'Draft' ? this.job.clientorbu.id : this.req.clientOrBU.id
            };
            this.candidateService.sendOutreachEmail(outreachObject, function (data) {
                _this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    UploadReqPageController.prototype.updateUserCache = function () {
        // Update User Cache
        this.userService.userCache(null, function () { }, function () { });
    };
    UploadReqPageController.prototype.setWorkflowStepsOrderInIcons = function (workflowSteps) {
        var steps = [
            { key: 'recruiterScreening', label: 'Recruiter Screening' },
            { key: 'techAssessment', label: 'Tech Assessment' },
            { key: 'valueAssessment', label: 'Value Assessment' },
            { key: 'phoneScreen', label: 'Phone Screen' },
            { key: 'interview', label: 'Interview' }
        ];
        this.requisitionInfo.workflowSteps = steps
            .filter(function (step) { return workflowSteps[step.key]; })
            .map(function (step) { return step.label; });
    };
    UploadReqPageController.prototype.updateRequisitionIcons = function (data) {
        var _this = this;
        if (data && this.currentJobStatus != 'DRAFT') {
            if (data.vendorIds && data.vendorIds.length > 0) {
                this.requisitionInfo.vendorsDetails = [];
                this.vendorsList.forEach(function (vendor) {
                    if (data.vendorIds.includes(vendor.vendorId)) {
                        var vendorTemp = {
                            id: vendor.vendorId,
                            name: vendor.vendorName
                        };
                        _this.requisitionInfo.vendorsDetails.push(vendorTemp);
                    }
                });
            }
            else {
                this.requisitionInfo.vendorsDetails = [];
            }
            if (data.jobSalary) {
                this.job.requisitionSalaryDisplayMessage = this.requisitionService._getSalaryDetailsDisplayMessage(data.jobSalary, this.allSalaryDurationOptions);
            }
            this.requisitionInfo = tslib_1.__assign({}, this.requisitionInfo, { fourDotFiveIntelligentThresholdScore: data.fourDotFiveIntelligenceScore, autoMatedMatchSelected: data.licensePreferences.autoMatch, techAssessmentId: data.techAssessmentId, valueAssessmentId: data.valueAssessmentId });
            this.setWorkflowStepsOrderInIcons(data.licensePreferences);
        }
    };
    UploadReqPageController.prototype.createRequisitionWithouFile = function (successCallback, errorCallback) {
        var _this = this;
        var clientOrBUIdStepOne = this.req.clientOrBU ? this.req.clientOrBU.id : "";
        this.setProfileCriteriaInfoSkills(this.job.profileCriteriaInfo);
        var step1DetailsTempObject = tslib_1.__assign({}, this.job.profileCriteriaInfo);
        step1DetailsTempObject.title = this.job.title;
        if (this.job.location && this.job.location.city) {
            step1DetailsTempObject.location = tslib_1.__assign({}, this.job.location);
            step1DetailsTempObject.location.city = { name: this.job.location.city };
        }
        step1DetailsTempObject.sharedClientBuOrCorpId = this.req.sharedClientBuOrCorpId;
        step1DetailsTempObject.isSharedClientRequisition = this.req.isSharedClientRequisition;
        step1DetailsTempObject.userEnteredDescription = true;
        var companyId = this.userDetails.company.companyId;
        this.utilityService.showLoadingModal("Saving...");
        this.requisitionSkillsLoading = true;
        step1DetailsTempObject.source = 'CREATEREQ';
        this.jobService.createJobDescription(step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.userDetails.id, function (data) {
            _this.job = _this._parseJobResponse(data);
            _this._setSponsorshipSelectedDefault(false);
            _this._createStepTempObject(1);
            _this._createStepTempObject(2);
            _this.getAllJobBoards(function () {
                _this._setJobBoardDetails();
            });
            // this._massageWorkflowStepsOrder();
            _this.updateActionButtons();
            // Edit requisition Details
            _this.isEditRequisitionDetails = true;
            _this.isUploadRequisition = false;
            _this.isUploadAndEditRadioBtn = false;
            _this.requisitionSkillsLoading = false;
            _this.isClientOrBuDisabled = true;
            _this.updateUserCache();
            _this.utilityService.hideLoadingModal();
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.requisitionSkillsLoading = false;
            _this.utilityService.hideLoadingModal();
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    UploadReqPageController.prototype.reRunResumeScore = function (message, successCallback) {
        var _this = this;
        var requestObject = new RunCandidateScore(this.companyId, this.userId);
        requestObject.jobId = this.job.id;
        requestObject.rerunType = "REQUISITION";
        requestObject.source = "EDITREQ";
        this.resumeService.reRunResumeScore(requestObject, function (data) {
            _this.alertsAndNotificationsService.showAlertWithCallBack("Candidate scoring in Progress", message ? message : data.message, "success", function () {
                _this.isRecalcucateScoreNoClicked = false;
                if (successCallback) {
                    successCallback();
                }
            });
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadReqPageController.prototype.hasMatchingMandatoryCriteriaChanged = function () {
        return (this.workflowStepsTempObject.includeCandidatesMatchingMandatoryCriteria != this.job.includeCandidatesMatchingMandatoryCriteria);
    };
    UploadReqPageController.prototype.hasMissingPreferenceDetailsChanged = function () {
        return (this.workflowStepsTempObject.includeCandidatesWithNoAdditionalDetails != this.job.includeCandidatesWithNoAdditionalDetails);
    };
    UploadReqPageController.prototype.checkIfFlagsChanged = function (currentStep1TempObject, step1DetailsTempObject) {
        return (step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails !== currentStep1TempObject.includeCandidatesWithNoAdditionalDetails) ||
            (step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria !== currentStep1TempObject.includeCandidatesMatchingMandatoryCriteria);
    };
    //Handle navigating away when data is unsaved
    UploadReqPageController.prototype.uiCanExit = function (transitions) {
        var _this = this;
        var toState = transitions.to().name;
        var toParams = transitions.params();
        var currentStep = $("#uploadReqWizard").wizard('selectedItem');
        if (this._hasStepDataChanged(currentStep.step) && !this.isUiCanExit && this.isTransitionAbortRequired && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        if (_this.isRecalcucateScoreNoClicked) {
                            _this.reRunResumeScore('Recalculating the scores now and you will be notified when it is completed', function () { });
                        }
                        _this.isTransitionAbortRequired = false;
                        _this.resetStepData(currentStep.step);
                        // Handling data change when clicked on Switch company 
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                            // this.companyService.showAllCompanies();
                            _this.uibModalService.showAllCompanies();
                        }
                        else {
                            _this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._hasStepDataChanged(currentStep.step)) {
                transitions.abort();
                this.$timeout(function () {
                    // this.companyService.showAllCompanies();
                    _this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    };
    UploadReqPageController.prototype._handleBrowserEvents = function () {
        var _this = this;
        //Handle Browser back/forward change
        var unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', function (event, toState, toParams, fromState, fromParams) {
            _this.isLocationChange = _this.isLocationChangeInitial;
            _this.isLocationChangeInitial = true;
        });
    };
    UploadReqPageController.prototype.receiveFormalizedComment = function (event) {
        this.job.requisitionNote = event;
    };
    UploadReqPageController.prototype.onVoiceTranscript = function (transcript) {
        if (this.job.requisitionNote) {
            this.job.requisitionNote += ' ' + transcript;
        }
        else {
            this.job.requisitionNote = transcript;
        }
    };
    UploadReqPageController.prototype.setFormalizeActivityPayload = function () {
        if (this.editModeFlag) {
            this.formalizeActivityPayload = {
                candidate: null,
                requisition: new FormalizeRequisition(this.job.id, this.job.requisitionNumber, this.job.title),
                jobMatch: null,
                company: new FormalizeCompany(this.job.company.id, this.job.company.name, this.job.clientorbu.id, this.job.clientorbu.name)
            };
        }
    };
    return UploadReqPageController;
}());
export { UploadReqPageController };
UploadReqPageController.$inject = ['$rootScope', '$scope', '$state', '$transitions', '$uibModal', '$sce', '$timeout', 'requisitionService', 'candidateService', 'resumeService',
    'jobService', 'assessmentService', 'planService', 'companyService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'uibModalService', 'utilityService', 'userService', 'manageSkillsService', 'stateManagementStorageService'];
// import * as TEMPLATE from './upload-req-page.html';
import * as TEMPLATE from 'raw-loader!./upload-req-page.html';
export var UploadReqPageComponent = {
    selector: 'uploadReqPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/uploadreq/upload-req-page.html',
        controller: UploadReqPageController
    }
};
//# sourceMappingURL=upload-req-page.component.js.map